(function(){
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  function toggleHidden(el, show) {
    if (!el) return;
    el.hidden = !show;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(amount);
    } catch (e) {
      return `$${amount.toFixed(2)}`;
    }
  }

  function escapeHTML(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function getCartVariantTitle(value) {
    return String(value || '')
      .split(' / ')
      .map((part) => part.trim())
      .filter((part) => part && !/^(default title|united states|usa|u\.s\.a\.|us|u\.s\.)$/i.test(part))
      .join(' / ');
  }

  const mobileMenu = $('#PiMobileMenu');
  const mobileMenuTrigger = $('[data-mobile-menu-toggle]');

  function setPageDrawerLock(isLocked) {
    document.documentElement.classList.toggle('pi-drawer-lock', Boolean(isLocked));
    document.body.classList.toggle('pi-drawer-lock', Boolean(isLocked));
  }

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenuTrigger?.setAttribute('aria-expanded', 'true');
    toggleHidden(mobileMenu, true);
    setPageDrawerLock(true);
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenuTrigger?.setAttribute('aria-expanded', 'false');
    toggleHidden(mobileMenu, false);
    setPageDrawerLock(false);
  }

  mobileMenuTrigger?.addEventListener('click', openMobileMenu);
  $$('[data-mobile-menu-close]').forEach((btn) => btn.addEventListener('click', closeMobileMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) closeMobileMenu();
  });

  const categoryDropdown = $('[data-category-dropdown]');
  const categoryDropdownToggle = $('[data-category-dropdown-toggle]');
  const categoryDropdownMenu = $('[data-category-dropdown-menu]');

  function closeCategoryDropdown() {
    if (!categoryDropdown || !categoryDropdownToggle || !categoryDropdownMenu) return;
    categoryDropdown.classList.remove('is-open');
    categoryDropdownToggle.setAttribute('aria-expanded', 'false');
    toggleHidden(categoryDropdownMenu, false);
  }

  function openCategoryDropdown() {
    if (!categoryDropdown || !categoryDropdownToggle || !categoryDropdownMenu) return;
    categoryDropdown.classList.add('is-open');
    categoryDropdownToggle.setAttribute('aria-expanded', 'true');
    toggleHidden(categoryDropdownMenu, true);
  }

  categoryDropdownToggle?.addEventListener('click', (e) => {
    e.preventDefault();
    if (categoryDropdown?.classList.contains('is-open')) {
      closeCategoryDropdown();
    } else {
      openCategoryDropdown();
    }
  });


  const cartDrawer = $('#CartDrawer');
  function openCartDrawer() { toggleHidden(cartDrawer, true); }
  function closeCartDrawer() { toggleHidden(cartDrawer, false); }
  $$('[data-open-cart]').forEach((btn) => btn.addEventListener('click', openCartDrawer));
  $$('[data-cart-close]').forEach((btn) => btn.addEventListener('click', closeCartDrawer));

  const vehicleDrawer = $('#VehicleDrawer');
  function openVehicleDrawer() {
    toggleHidden(vehicleDrawer, true);
    document.body.classList.add('pi-no-scroll');
    $$('[data-open-vehicle]').forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
  }
  function closeVehicleDrawer() {
    toggleHidden(vehicleDrawer, false);
    document.body.classList.remove('pi-no-scroll');
    $$('[data-open-vehicle]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }
  $$('[data-open-vehicle]').forEach((btn) => btn.addEventListener('click', openVehicleDrawer));
  $$('[data-vehicle-drawer-close]').forEach((btn) => btn.addEventListener('click', closeVehicleDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeVehicleDrawer();
      closeCartDrawer();
      closeCategoryDropdown();
    }
  });

  async function refreshCartDrawer() {
    try {
      const res = await fetch(`${window.location.origin}/cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const cartCount = Number(cart.item_count) || 0;
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cartCount;
        el.classList.toggle('is-empty', cartCount < 1);
        el.setAttribute('aria-label', `${cartCount} ${cartCount === 1 ? 'item' : 'items'} in cart`);
        el.closest('[data-open-cart]')?.classList.toggle('has-cart-items', cartCount > 0);
      });
      const body = $('[data-cart-drawer-body]');
      const subtotalWrap = $('[data-cart-drawer-subtotal]');
      const subtotalPrice = $('[data-cart-drawer-subtotal-price]');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<p class="pi-text-muted">Your cart is empty.</p>';
        if (subtotalWrap) subtotalWrap.hidden = true;
        if (subtotalPrice) subtotalPrice.textContent = formatMoney(0);
        return;
      }
      if (subtotalWrap) subtotalWrap.hidden = false;
      if (subtotalPrice) subtotalPrice.textContent = formatMoney(cart.total_price);
      body.innerHTML = cart.items.map((item) => {
        const itemTitle = escapeHTML(item.product_title);
        const itemImage = item.image ? `<img class="pi-cart-drawer__item-image" src="${item.image}" alt="${itemTitle}">` : '<div class="pi-cart-drawer__item-image pi-cart-drawer__item-image--empty" aria-hidden="true"></div>';
        return `
        <div class="pi-cart-drawer__item" data-cart-drawer-item>
          ${itemImage}
          <div class="pi-cart-drawer__item-info">
            <div class="pi-cart-drawer__item-top">
              <div class="pi-cart-drawer__item-copy">
                <div class="pi-cart-drawer__item-title"><strong>${itemTitle}</strong></div>
                <span class="pi-cart-drawer__item-price"><span class="pi-cart-drawer__price-label">Unit price</span> ${formatMoney(item.final_price)}</span>
              </div>
              <button type="button" class="pi-cart-drawer__remove" data-cart-drawer-remove data-line-key="${item.key}" aria-label="Remove ${itemTitle} from cart">Remove</button>
            </div>
            <div class="pi-cart-drawer__item-bottom">
              <span class="pi-cart-drawer__item-qty">Qty: ${item.quantity}</span>
            </div>
          </div>
        </div>`;
      }).join('');
    } catch (e) {
      /* fail silently and preserve full-cart fallback */
    }
  }

  $$('form[data-ajax-add-to-cart]').forEach((form) => form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const submit = e.submitter || $('button[type="submit"]', form);
    const isBuyNow = !!(submit && submit.matches('[data-buy-now]'));
    if (submit) submit.disabled = true;
    const formData = new FormData(form);
    try {
      const res = await fetch(window.themeRoutes.cartAdd, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Cart add failed');
      if (isBuyNow) {
        window.location.href = '/checkout';
        return;
      }
      await refreshCartDrawer();
      document.dispatchEvent(new CustomEvent("pi:cart-added", {
        detail: {
          form,
          variantId: String(formData.get("id") || "")
        }
      }));
      openCartDrawer();
    } catch (err) {
      window.location.href = isBuyNow ? '/checkout' : window.themeRoutes.cart;
    } finally {
      if (!isBuyNow && submit) submit.disabled = false;
    }
  }));
  refreshCartDrawer();

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-cart-drawer-remove]');
    if (!removeButton) return;
    const lineKey = removeButton.dataset.lineKey;
    if (!lineKey) return;
    removeButton.disabled = true;
    removeButton.classList.add('is-loading');
    const originalText = removeButton.textContent;
    removeButton.textContent = 'Removing';
    try {
      const res = await fetch(`${window.location.origin}/cart/change.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      if (!res.ok) throw new Error('Cart remove failed');
      await refreshCartDrawer();
      openCartDrawer();
    } catch (err) {
      window.location.href = window.themeRoutes?.cart || '/cart';
    } finally {
      removeButton.disabled = false;
      removeButton.classList.remove('is-loading');
      removeButton.textContent = originalText || 'Remove';
    }
  });

  function syncGalleryThumbState(root, activeThumb) {
    if (!root) return;
    $$('.pi-thumb', root).forEach((thumb) => thumb.classList.remove('is-active'));
    activeThumb?.classList.add('is-active');
  }

  function closeGalleryZoom(zoom) {
    if (!zoom) return;
    zoom.hidden = true;
    document.body.classList.remove('pi-no-scroll');
  }

  function openGalleryZoom(gallery) {
    if (!gallery) return;
    const zoom = $('[data-gallery-zoom]', gallery);
    const img = $('[data-gallery-main]', gallery);
    const zoomImg = $('[data-gallery-zoom-image]', gallery);
    if (!zoom || !img || !zoomImg) return;
    zoomImg.src = img.dataset.zoomSrc || img.currentSrc || img.src;
    zoomImg.alt = img.alt || '';
    zoom.hidden = false;
    document.body.classList.add('pi-no-scroll');
  }

  function updateGalleryImage(gallery, thumb) {
    if (!gallery || !thumb) return;
    const img = $('[data-gallery-main]', gallery);
    const zoomImg = $('[data-gallery-zoom-image]', gallery);
    const zoomRoot = $('[data-gallery-zoom]', gallery);
    const src = thumb.dataset.imageSrc || $('img', thumb)?.currentSrc || $('img', thumb)?.src;
    const zoomSrc = thumb.dataset.imageZoomSrc || src;
    const alt = thumb.dataset.imageAlt || $('img', thumb)?.alt || '';
    if (!img || !src) return;
    img.src = src;
    img.dataset.zoomSrc = zoomSrc;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (alt) img.alt = alt;
    if (zoomImg && zoomRoot && !zoomRoot.hidden) {
      zoomImg.src = zoomSrc;
      if (alt) zoomImg.alt = alt;
    }
    syncGalleryThumbState(gallery, thumb);
  }

  function initProductPageGalleries() {
    const isProductPage = document.body.classList.contains('template-product') || !!document.querySelector('[data-product-page-gallery]');
    if (!isProductPage) return;

    const galleries = $$('[data-product-page-gallery]');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      const zoomTrigger = $('[data-gallery-zoom-trigger]', gallery);
      const zoomRoot = $('[data-gallery-zoom]', gallery);

      $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          updateGalleryImage(gallery, thumb);
        });
      });

      zoomTrigger?.addEventListener('click', (e) => {
        e.preventDefault();
        openGalleryZoom(gallery);
      });

      $$('[data-gallery-zoom-close]', gallery).forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          closeGalleryZoom(zoomRoot);
        });
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      $$('[data-gallery-zoom]', document).forEach((zoom) => {
        if (!zoom.hidden) closeGalleryZoom(zoom);
      });
    });
  }

  initProductPageGalleries();


  function initMobileProductSwipeGalleries() {
    const galleries = $$('[data-product-mobile-gallery]');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      const track = $('[data-product-mobile-gallery-track]', gallery);
      const slides = $$('[data-mobile-gallery-slide]', gallery);
      const dots = $$('[data-mobile-gallery-dot]', gallery);
      const zoom = $('[data-mobile-gallery-zoom]', gallery);
      const zoomImage = $('[data-mobile-gallery-zoom-image]', gallery);
      if (!track || !slides.length) return;

      let pointerStartX = 0;
      let pointerStartY = 0;
      let didSwipe = false;
      let scrollTimer = null;

      const setActiveDot = () => {
        if (!dots.length) return;
        const slideWidth = track.clientWidth || 1;
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / slideWidth)));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      track.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        didSwipe = false;
      }, { passive: true });

      track.addEventListener('pointermove', (event) => {
        const movedX = Math.abs(event.clientX - pointerStartX);
        const movedY = Math.abs(event.clientY - pointerStartY);
        if (movedX > 8 && movedX > movedY) didSwipe = true;
      }, { passive: true });

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(setActiveDot, 60);
      }, { passive: true });

      slides.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          if (didSwipe) {
            event.preventDefault();
            didSwipe = false;
            return;
          }
          if (!zoom || !zoomImage) return;
          event.preventDefault();
          const zoomSrc = slide.dataset.mobileZoomSrc || $('img', slide)?.currentSrc || $('img', slide)?.src;
          const zoomAlt = slide.dataset.mobileImageAlt || $('img', slide)?.alt || '';
          if (!zoomSrc) return;
          zoomImage.src = zoomSrc;
          zoomImage.alt = zoomAlt;
          zoom.hidden = false;
          document.body.classList.add('pi-no-scroll');
        });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          const index = Number(dot.dataset.galleryIndex || 0);
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });

      $$('[data-mobile-gallery-zoom-close]', gallery).forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          closeGalleryZoom(zoom);
        });
      });

      setActiveDot();
    });
  }

  initMobileProductSwipeGalleries();

  $$('[data-qty-increase]').forEach((btn) => btn.addEventListener('click', () => {
    const wrap = btn.closest('.pi-qty-control') || btn.closest('.pi-qty-inline');
    const input = $('input[type="number"]', wrap);
    if (!input) return;
    input.stepUp();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  $$('[data-qty-decrease]').forEach((btn) => btn.addEventListener('click', () => {
    const wrap = btn.closest('.pi-qty-control') || btn.closest('.pi-qty-inline');
    const input = $('input[type="number"]', wrap);
    if (!input) return;
    const min = Number(input.min || 0);
    const next = Math.max(min, Number(input.value || min) - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  $$('[data-tab-target]').forEach((btn) => btn.addEventListener('click', () => {
    const root = btn.closest('[data-tabs]');
    if (!root) return;
    $$('[data-tab-target]', root).forEach((x) => x.classList.remove('is-active'));
    btn.classList.add('is-active');
    $$('[data-tab-panel]', root).forEach((x) => x.classList.remove('is-active'));
    root.querySelector(`[data-tab-panel="${btn.dataset.tabTarget}"]`)?.classList.add('is-active');
  }));


  function sortCategoryLinksIn(container) {
    if (!container) return;
    const items = Array.from(container.children).filter((item) => item.matches('.pi-category-item, .pi-category-link, .pi-mobile-category-link, div[aria-disabled="true"]'));
    if (!items.length) return;
    const sorted = items.slice().sort((a, b) => {
      const aLabel = (a.querySelector('.pi-category-link__label, .pi-mobile-category-link__label')?.textContent || a.textContent || '').trim().toLowerCase();
      const bLabel = (b.querySelector('.pi-category-link__label, .pi-mobile-category-link__label')?.textContent || b.textContent || '').trim().toLowerCase();
      return aLabel.localeCompare(bLabel);
    });
    sorted.forEach((item) => container.appendChild(item));
  }

  function sortAllCategoryMenus() {
    sortCategoryLinksIn($('.pi-category-dropdown__grid'));
    sortCategoryLinksIn($('.pi-mobile-category-grid'));
  }

  sortAllCategoryMenus();

  const filterToggle = $('[data-filter-toggle]');
  const filtersPanel = $('[data-filters-panel]');
  filterToggle?.addEventListener('click', () => {
    filtersPanel?.classList.toggle('is-open');
  });


  function syncCatalogSidebarFromMenu() {
    const sidebar = $('.pi-catalog-sidebar');
    const sidebarList = $('[data-catalog-sidebar-list]');
    if (!sidebarList) return;
    const sourceItems = Array.from(document.querySelectorAll('.pi-category-dropdown__grid > .pi-category-item, .pi-category-dropdown__grid > .pi-category-link, .pi-category-dropdown__grid > div[aria-disabled="true"]'));
    if (!sourceItems.length) return;

    const normalizePath = (path) => (path || '/').replace(/\/$/, '') || '/';
    const currentPath = normalizePath(window.location.pathname); const currentUrl = new URL(window.location.href);
    let activeClone = null; let activeSubmenu = null;

    sidebarList.innerHTML = '';
    sourceItems.forEach((item) => { const sourcePanel = item.querySelector('[data-category-submenu-panel]'); const activeSourceSublink = sourcePanel ? Array.from(sourcePanel.querySelectorAll('a')).find((link) => { const linkUrl = new URL(link.getAttribute('href'), window.location.origin); return normalizePath(linkUrl.pathname) === currentPath && linkUrl.searchParams.get('q') === (currentUrl.searchParams.get('catalog_q') || currentUrl.searchParams.get('q')) && (linkUrl.searchParams.get('type') || '') === (currentUrl.searchParams.get('type') || ''); }) : null;
      let clone; if (item.matches('.pi-category-item')) { const trigger = item.querySelector('[data-category-submenu-toggle]'); if (!trigger) return; clone = document.createElement('a'); Array.from(trigger.attributes).forEach((attribute) => { if (!['type', 'aria-expanded', 'data-category-submenu-toggle', 'data-category-main-url'].includes(attribute.name)) clone.setAttribute(attribute.name, attribute.value); }); clone.href = trigger.dataset.categoryMainUrl || '#'; clone.innerHTML = trigger.innerHTML; } else { clone = item.cloneNode(true); }
      clone.classList.remove('pi-category-link', 'pi-mobile-category-link', 'is-disabled');
      clone.classList.add('pi-catalog-sidebar__item');
      clone.setAttribute('role', 'listitem');

      const icon = clone.querySelector('.pi-category-link__icon, .pi-mobile-category-link__icon');
      if (icon) {
        icon.classList.remove('pi-category-link__icon', 'pi-mobile-category-link__icon');
        icon.classList.add('pi-catalog-sidebar__icon');
      }

      const label = clone.querySelector('.pi-category-link__label, .pi-mobile-category-link__label');
      if (label) {
        label.classList.remove('pi-category-link__label', 'pi-mobile-category-link__label');
        label.classList.add('pi-catalog-sidebar__label');
      }

      const svg = clone.querySelector('.pi-category-link__svg');
      if (svg) svg.classList.add('pi-catalog-sidebar__svg');

      if (clone.tagName !== 'A') {
        clone.classList.add('is-static');
      } else {
        try {
          const cloneUrl = new URL(clone.getAttribute('href'), window.location.origin);
          if (normalizePath(cloneUrl.pathname) === currentPath || activeSourceSublink) {
            clone.classList.add('is-active');
            clone.setAttribute('aria-current', 'page');
            activeClone = clone; if (sourcePanel) activeSubmenu = sourcePanel.cloneNode(true); if (activeSubmenu && activeSourceSublink) { const activeHref = activeSourceSublink.getAttribute('href'); const activeSidebarSublink = Array.from(activeSubmenu.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref); if (activeSidebarSublink) { activeSidebarSublink.classList.add('is-active'); activeSidebarSublink.setAttribute('aria-current', 'page'); const contextLabel = (activeSourceSublink.textContent || '').trim(); const contextHeading = $('[data-search-results-heading]'); if (contextHeading && contextLabel) contextHeading.textContent = contextLabel; const contextBreadcrumb = $('[data-search-category-breadcrumb]'); if (contextBreadcrumb && contextLabel) { const parentHolder = contextBreadcrumb.querySelector('[data-search-category-parent]'); const currentHolder = contextBreadcrumb.querySelector('[data-search-category-current]'); const parentLabel = (clone.querySelector('.pi-catalog-sidebar__label')?.textContent || '').trim(); if (parentHolder && currentHolder && parentLabel) { const parentLink = document.createElement('a'); parentLink.href = clone.getAttribute('href') || '#'; parentLink.textContent = parentLabel; parentHolder.replaceChildren(parentLink); currentHolder.textContent = contextLabel; contextBreadcrumb.hidden = false; } } } }
          }
        } catch (e) {
          /* ignore malformed url */
        }
      }

      sidebarList.appendChild(clone);
    });

    if (activeClone) {
      sidebarList.prepend(activeClone); if (activeSubmenu) { activeSubmenu.hidden = false; activeSubmenu.className = 'pi-catalog-sidebar__submenu'; activeSubmenu.removeAttribute('aria-label');  activeSubmenu.querySelectorAll('.pi-category-submenu__link').forEach((link) => { link.classList.remove('pi-category-submenu__link', 'pi-category-submenu__link--all'); link.classList.add('pi-catalog-sidebar__sublink'); }); sidebarList.insertBefore(activeSubmenu, activeClone.nextSibling); }
      sidebar?.classList.add('has-active-category');
      const activeLabel = activeClone.querySelector('.pi-catalog-sidebar__label')?.textContent?.trim();
      if (activeLabel) sidebar?.setAttribute('data-active-category', activeLabel);
    }
  }

  function initCatalogSidebarMotion() {
    const sidebar = $('.pi-catalog-sidebar');
    if (!sidebar) return;
    sidebar.classList.remove('is-scrolling', 'is-scrolling-up', 'is-scrolling-down');
  }

  syncCatalogSidebarFromMenu();
  initCatalogSidebarMotion();

  $$('[data-view-mode]').forEach((btn) => btn.addEventListener('click', () => {
    const grid = $('[data-product-grid]');
    if (!grid) return;
    $$('[data-view-mode]').forEach((x) => x.classList.remove('is-active'));
    btn.classList.add('is-active');
    grid.dataset.view = btn.dataset.viewMode;
  }));

  function compactSizeNumber(value) {
    return String(value || '')
      .trim()
      .replace(/\.0+$/, '')
      .replace(/(\.\d*?)0+$/, '$1');
  }

  function uniqueSizeLabels(values) {
    return Array.from(new Set(values.filter(Boolean)));
  }

  function sortSizeLabels(a, b) {
    const numsA = (a.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    const numsB = (b.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    const max = Math.max(numsA.length, numsB.length);
    for (let i = 0; i < max; i += 1) {
      const diff = (numsA[i] || 0) - (numsB[i] || 0);
      if (diff) return diff;
    }
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  }

  function extractSizeLabels(text, regex, formatter) {
    const labels = [];
    let match;
    regex.lastIndex = 0;
    while ((match = regex.exec(text)) !== null) {
      labels.push(formatter(match));
    }
    return uniqueSizeLabels(labels);
  }

  function normalizeSizeValue(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/×/g, 'X')
      .replace(/ZR|\bR(?=\d)/g, '/')
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9./X-]/g, '');
  }

  function normalizeSizeCompact(value) {
    return normalizeSizeValue(value).replace(/[^A-Z0-9]/g, '');
  }

  async function initTireWheelFilters() {
    const root = $('[data-tire-wheel-filters]');
    if (!root) return;

    const mode = root.dataset.sizeFilterMode === 'wheel' ? 'wheel' : 'tire';
    const tireSelect = $('[data-tire-size-filter]', root);
    const wheelSelect = $('[data-wheel-size-filter]', root);
    const activeSelect = mode === 'tire' ? tireSelect : wheelSelect;
    const goButton = $('[data-size-filter-go]', root);
    const clearButton = $('[data-size-filter-clear]', root);
    if (!activeSelect) return;

    const tireSizes = ["22x11R10","27x8.5R14","31x10.5R15","32x10R15","33x12.5R18","33x12.5R20","33x12.5R22","33x12.5R24","35x10.5R15","35x11.5R20","35x12.5R20","35x12.5R22","35x13.5R20","35x13.5R22","35x14.5R26","37x13.5R26","155/80/13","165/80/13","175/60/15","175/65/14","175/65/15","175/70/13","175/70/14","175/80/13","185/55/15","185/60/14","185/60/15","185/65/14","185/65/15","185/70/14","195/35/18","195/45/15","195/50/15","195/50/16","195/55/16","195/60/15","195/60/16","195/65/15","195/70/14","195/75/14","205/40/17","205/45/16","205/50/16","205/50/17","205/55/16","205/60/15","205/60/16","205/65/15","205/65/16","205/70/15","205/75/14","205/75/15","215/35/18","215/40/17","215/40/18","215/45/17","215/50/17","215/50/18","215/55/16","215/55/17","215/60/15","215/60/16","215/60/17","215/65/17","215/70/14","215/70/15","215/70/16","215/75/14","215/75/15","225/35/19","225/35/20","225/40/18","225/40/19","225/45/17","225/45/18","225/45/19","225/50/17","225/55/16","225/55/17","225/55/18","225/55/19","225/60/16","225/60/17","225/60/18","225/65/17","225/70/16","225/75/15","225/75/16","235/35/19","235/35/20","235/40/18","235/40/19","235/45/18","235/50/18","235/50/20","235/55/17","235/55/18","235/55/19","235/55/20","235/60/16","235/60/17","235/60/18","235/65/16","235/65/17","235/65/18","235/70/15","235/70/16","235/75/15","235/80/16","235/80/17","235/85/16","245/30/20","245/35/20","245/40/17","245/40/18","245/40/19","245/40/20","245/45/17","245/45/18","245/45/19","245/45/20","245/50/18","245/50/20","245/55/19","245/60/18","245/65/17","245/70/16","245/70/17","245/75/16","245/75/17","255/35/18","255/35/19","255/35/20","255/35/21","255/40/19","255/40/20","255/45/18","255/45/19","255/45/20","255/50/19","255/50/20","255/55/18","255/55/19","255/55/20","255/60/18","255/70/16","255/70/18","265/30/22","265/35/18","265/45/21","265/50/20","265/60/18","265/60/20","265/65/17","265/65/18","265/70/16","265/70/17","265/70/18","265/75/16","275/25/24","275/30/19","275/30/20","275/30/21","275/35/18","275/35/19","275/35/20","275/35/24","275/40/18","275/40/19","275/40/20","275/45/20","275/45/22","275/50/22","275/55/20","275/60/20","275/65/17","275/65/18","275/65/20","275/70/18","285/35/20","285/40/20","285/40/24","285/45/21","285/45/22","285/50/20","285/55/20","285/60/18","285/70/17","285/75/16","295/25/22","295/35/21","295/40/21","295/45/20","295/60/20","295/70/17","305/30/20","305/30/26","305/40/22","305/45/17","305/45/22","305/50/20","305/55/20","305/70/16","315/35/20","315/70/17","325/30/21","345/50/24"];
    const wheelSizes = ["14x7","15x8","15x10","16x8","17x7","17x8","17x8.5","17x9","17x9.5","18x7","18x7.5","18x8","18x8.5","18x9.5","18x11","19x7.5","19x9.5","22x9.5","24x10"];
    const collectionSizeBase = root.dataset.sizeBaseUrl || '';
    const collectionSizeTags = (root.dataset.collectionTags || '').split('||');
    const collectionSizeTagHandles = JSON.parse(root.querySelector('[data-size-tag-map]')?.textContent || '{}');
    const collectionSizeTag = (size) => {
      const matches = (tag) => normalizeSizeCompact(tag.replace(/^(?:Tire|Wheel) Size:?\s*/i, '')) === normalizeSizeCompact(size);
      return collectionSizeTags.find((tag) => /^(?:Tire|Wheel) Size:?\s*/i.test(tag) && matches(tag)) || collectionSizeTags.find(matches);
    };
    const availableSizes = (mode === 'tire' ? tireSizes : wheelSizes).filter((size) => !collectionSizeBase || collectionSizeTag(size));
    const sizeParam = mode === 'tire' ? 'tire_size' : 'wheel_size';
    const baseQuery = mode === 'tire'
      ? 'product_type:"Tire & Wheel" AND tag:"Tire Size"'
      : 'product_type:"Tire & Wheel" AND tag:"Wheel Size"';

    const populateSelect = (select, values, label) => {
      if (!select) return;
      select.replaceChildren();
      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = 'All ' + label + ' sizes';
      select.appendChild(allOption);
      values.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      select.disabled = false;
    };

    populateSelect(tireSelect, mode === 'tire' ? availableSizes : tireSizes, 'tire');
    populateSelect(wheelSelect, mode === 'wheel' ? availableSizes : wheelSizes, 'wheel');

    const params = new URLSearchParams(window.location.search);
    const selectedSizeTags = JSON.parse(root.dataset.requiredTags || '[]') || [];
    const initialSize = params.get(sizeParam) || availableSizes.find((size) => selectedSizeTags.includes(collectionSizeTag(size))) || '';
    if (initialSize && availableSizes.includes(initialSize)) activeSelect.value = initialSize;
    if (clearButton) clearButton.hidden = !activeSelect.value;

    const buildFilteredQuery = (size) => {
      if (!size) return baseQuery;
      if (mode === 'wheel') {
        return baseQuery + ' AND (tag:"Wheel Size: ' + size + '" OR tag:"Wheel Size ' + size + '" OR tag:"' + size + '")';
      }
      if (/^\d{3}\/\d{2}\/\d{2}$/.test(size)) {
        return baseQuery + ' AND (tag:"Tire Size ' + size + '" OR tag:"' + size + '")';
      }
      return baseQuery + ' AND tag:"' + size.toUpperCase() + '"';
    };

    const goToSize = (size) => {
      const currentUrl = new URL(window.location.href);
      if (collectionSizeBase) {
        const nextCollection = new URL(collectionSizeBase, window.location.origin);
        const tag = size ? collectionSizeTag(size) : '';
        if (size && !tag) return;
        if (tag) nextCollection.pathname += '+' + collectionSizeTagHandles[tag];
        const sort = currentUrl.searchParams.get('sort_by');
        if (sort) nextCollection.searchParams.set('sort_by', sort);
        if (size) nextCollection.searchParams.set(sizeParam, size);
        window.location.assign(nextCollection.href);
        return;
      }
      const nextUrl = new URL('/search', window.location.origin);
      nextUrl.searchParams.set('q', buildFilteredQuery(size));
      nextUrl.searchParams.set('type', 'product');
      const currentSort = currentUrl.searchParams.get('sort_by');
      if (currentSort) nextUrl.searchParams.set('sort_by', currentSort);
      if (size) {
        nextUrl.searchParams.set(sizeParam, size);
        nextUrl.searchParams.set('catalog_q', baseQuery);
      }
      window.location.assign(nextUrl.toString());
    };

    activeSelect.addEventListener('change', () => {
      if (clearButton) clearButton.hidden = !activeSelect.value;
    });

    goButton?.addEventListener('click', (event) => {
      event.preventDefault();
      goToSize(activeSelect.value || '');
    });

    clearButton?.addEventListener('click', (event) => {
      event.preventDefault();
      goToSize('');
    });
  }

  initTireWheelFilters().catch(() => {
    const goButton = $('[data-size-filter-go]');
    if (goButton) {
      goButton.disabled = false;
      goButton.textContent = 'Go';
    }
  });

  const predictiveInput = $('[data-predictive-search-input]');
  const predictiveResults = $('[data-predictive-search-results]');
  let predictiveTimer;
  predictiveInput?.addEventListener('input', () => {
    clearTimeout(predictiveTimer);
    const term = predictiveInput.value.trim();
    if (!term.length) {
      if (predictiveResults) {
        predictiveResults.innerHTML = '';
        predictiveResults.hidden = true;
      }
      return;
    }
    predictiveTimer = setTimeout(async () => {
      try {
        const url = `${window.themeRoutes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection,article,page&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.body.innerHTML.trim();
        if (predictiveResults) {
          predictiveResults.innerHTML = content || '<p class="pi-text-muted">No results found.</p>';
          predictiveResults.hidden = false;
        }
      } catch (e) {
        if (predictiveResults) predictiveResults.hidden = true;
      }
    }, 180);
  });
  document.addEventListener('click', (e) => {
    if (predictiveResults && !e.target.closest('predictive-search')) {
      predictiveResults.hidden = true;
    }
  });
  document.addEventListener('click', (e) => {
    if (!categoryDropdown || categoryDropdown.contains(e.target)) return;
    closeCategoryDropdown();
  });


  const supportDrawer = $('#PiSupportDrawer');
  const supportTitle = $('[data-support-title]', supportDrawer || document);
  const supportPanels = supportDrawer ? $$('[data-support-panel]', supportDrawer) : [];
  const supportNavButtons = supportDrawer ? $$('[data-support-nav]', supportDrawer) : [];

  function closeSupportDrawer() {
    if (!supportDrawer) return;
    toggleHidden(supportDrawer, false);
  }

  function openSupportDrawer(view) {
    if (!supportDrawer) return;
    const selectedView = view || 'contact';
    toggleHidden(supportDrawer, true);
    supportPanels.forEach((panel) => {
      const isMatch = panel.dataset.supportPanel === selectedView;
      panel.hidden = !isMatch;
      panel.classList.toggle('is-active', isMatch);
      if (isMatch && supportTitle) {
        supportTitle.textContent = panel.dataset.supportLabel || 'Support';
      }
    });
    supportNavButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.supportNav === selectedView);
    });
  }

  $$('[data-support-open]').forEach((btn) => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openSupportDrawer(btn.dataset.supportOpen);
  }));
  $$('[data-support-close]').forEach((btn) => btn.addEventListener('click', closeSupportDrawer));
  supportNavButtons.forEach((btn) => btn.addEventListener('click', () => openSupportDrawer(btn.dataset.supportNav)));

  if (supportDrawer) {
    const hash = window.location.hash || '';
    if (hash === '#PiHeaderSupportContactForm' || hash === '#contact_form' || $('[data-support-contact-success]', supportDrawer) || supportDrawer.querySelector('.errors, .form-errors')) {
      openSupportDrawer('contact');
    }
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCategoryDropdown();
      closeSupportDrawer();
    }
  });

  async function loadVehicleFinderData() {
    if (window.__piVehicleFinderData) return window.__piVehicleFinderData;
    const url = window.themeRoutes?.vehicleFinderData;
    if (!url) return null;
    try {
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('Vehicle finder asset unavailable');
      const data = await res.json();
      const patchUrl = window.themeRoutes?.vehicleFinderPatch;
      if (patchUrl) {
        try {
          const patchRes = await fetch(patchUrl, { headers: { Accept: 'application/json' } });
          if (patchRes.ok) {
            const patch = await patchRes.json();
            data.by_handle = data.by_handle && typeof data.by_handle === 'object' ? data.by_handle : {};
            Object.entries(patch?.by_handle || {}).forEach(([handle, fitments]) => {
              if (!data.by_handle[handle]) data.by_handle[handle] = fitments;
            });

            data.fitments = Array.isArray(data.fitments) ? data.fitments : [];
            const fitmentKey = (item) => JSON.stringify([item.year, item.make, item.model, item.engine]);
            const fitmentMap = new Map(data.fitments.map((item) => [fitmentKey(item), item]));
            (patch?.fitments || []).forEach((item) => {
              const key = fitmentKey(item);
              let current = fitmentMap.get(key);
              if (!current) {
                current = { ...item, handles: [] };
                data.fitments.push(current);
                fitmentMap.set(key, current);
              }
              (item.handles || []).forEach((handle) => {
                if (!current.handles.includes(handle)) current.handles.push(handle);
              });
            });

            data.catalog = data.catalog && typeof data.catalog === 'object' ? data.catalog : {};
            Object.entries(patch?.catalog || {}).forEach(([year, makes]) => {
              data.catalog[year] = data.catalog[year] || {};
              Object.entries(makes || {}).forEach(([make, models]) => {
                data.catalog[year][make] = Array.isArray(data.catalog[year][make]) ? data.catalog[year][make] : [];
                (models || []).forEach((model) => {
                  if (!data.catalog[year][make].includes(model)) data.catalog[year][make].push(model);
                });
                data.catalog[year][make].sort((a, b) => a.localeCompare(b));
              });
            });

            data.years = Object.keys(data.catalog).sort((a, b) => Number(b) - Number(a));
            const yearNumbers = data.years.map(Number).filter(Number.isFinite);
            if (yearNumbers.length) data.year_range = { from: Math.min(...yearNumbers), to: Math.max(...yearNumbers) };
            const handleEntries = Object.entries(data.by_handle);
            data.fitment_count = handleEntries.reduce((count, [, fitments]) => count + fitments.length, 0);
            data.product_count = handleEntries.length;
            data.exact_product_count = handleEntries.filter(([, fitments]) => fitments.some((item) => item.year !== '*' && item.model !== '*')).length;
            data.spark_make_only_product_count = Object.keys(data.make_only_by_handle || {}).length;
            if (patch?.vehicle_finder_data_patch) data.vehicle_finder_data_patch = patch.vehicle_finder_data_patch;
            if (patch?.generated_from && !String(data.generated_from || '').includes(patch.generated_from)) {
              data.generated_from = String(data.generated_from || '') + ' + ' + patch.generated_from;
            }
          }
        } catch (patchError) {
          // Keep the verified base finder available if an optional patch cannot load.
        }
      }
      window.__piVehicleFinderData = data;
      return data;
    } catch (e) {
      return null;
    }
  }

  function priceValueToCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return value;
    const parsed = Number(String(value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function normalizeCatalogProductForFitment(product) {
    if (!product || typeof product !== 'object') return null;
    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const firstVariant = variants.find((variant) => variant?.available === true) || variants[0] || {};
    const normalizedImages = Array.isArray(product.images)
      ? product.images.map((image) => typeof image === 'string' ? image : (image?.src || image?.url || '')).filter(Boolean)
      : [];
    const availableFromVariants = variants.some((variant) => variant?.available === true);
    return {
      ...product,
      tags,
      variants,
      images: normalizedImages,
      type: product.type || product.product_type || '',
      product_type: product.product_type || product.type || '',
      description: product.description || product.body_html || product.content || '',
      body_html: product.body_html || product.description || product.content || '',
      price: typeof product.price === 'number' ? product.price : priceValueToCents(product.price || firstVariant.price),
      compare_at_price: typeof product.compare_at_price === 'number' ? product.compare_at_price : priceValueToCents(product.compare_at_price || firstVariant.compare_at_price),
      available: typeof product.available === 'boolean' ? product.available : (variants.length ? availableFromVariants : true)
    };
  }

  const VEHICLE_TEXT_MATCH_CACHE_KEY = 'piVehicleTextMatchCatalogProducts:v6';
  const VEHICLE_TEXT_MATCH_CACHE_TTL = 5 * 60 * 1000;
  const VEHICLE_TEXT_MATCH_MAX_PAGES = 40;
  const VEHICLE_TEXT_MATCH_PAGE_BATCH_SIZE = 4;

  function readProductCache(cacheKey) {
    try {
      const raw = window.sessionStorage?.getItem(cacheKey);
      if (!raw) return null;
      const cached = JSON.parse(raw);
      if (!cached || !Array.isArray(cached.products) || Date.now() - Number(cached.savedAt || 0) > VEHICLE_TEXT_MATCH_CACHE_TTL) return null;
      return cached.products.map(normalizeCatalogProductForFitment).filter(Boolean);
    } catch (e) {
      return null;
    }
  }

  function writeProductCache(cacheKey, products) {
    try {
      window.sessionStorage?.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), products }));
    } catch (e) {
      // Storage can be unavailable or full. The theme still works without caching.
    }
  }

  async function fetchProductsJsonPage(url) {
    try {
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return [];
      const payload = await res.json();
      return Array.isArray(payload?.products) ? payload.products : [];
    } catch (e) {
      return [];
    }
  }

  async function loadVehicleTextMatchCatalogProducts() {
    if (window.__piVehicleTextMatchCatalogProducts) return window.__piVehicleTextMatchCatalogProducts;
    if (window.__piVehicleTextMatchCatalogPromise) return window.__piVehicleTextMatchCatalogPromise;

    const cached = readProductCache(VEHICLE_TEXT_MATCH_CACHE_KEY);
    if (cached) {
      window.__piVehicleTextMatchCatalogProducts = cached;
      return cached;
    }

    window.__piVehicleTextMatchCatalogPromise = (async () => {
      const products = [];
      const seenHandles = new Set();
      const pageSize = 250;

      const addProducts = (pageProducts) => {
        pageProducts.forEach((product) => {
          const normalized = normalizeCatalogProductForFitment(product);
          const handle = normalized?.handle || '';
          if (!handle || seenHandles.has(handle)) return;
          seenHandles.add(handle);
          products.push(normalized);
        });
      };

      // Scan the complete published catalog in small parallel batches. The previous
      // six-page cap stopped at 1,500 products, so newer manually added parts could
      // never be discovered when the store contained more products than that.
      for (let pageStart = 1; pageStart <= VEHICLE_TEXT_MATCH_MAX_PAGES; pageStart += VEHICLE_TEXT_MATCH_PAGE_BATCH_SIZE) {
        const pageNumbers = Array.from(
          { length: Math.min(VEHICLE_TEXT_MATCH_PAGE_BATCH_SIZE, VEHICLE_TEXT_MATCH_MAX_PAGES - pageStart + 1) },
          (_, index) => pageStart + index
        );
        const pagePayloads = await Promise.all(
          pageNumbers.map((page) => fetchProductsJsonPage(`/collections/all/products.json?limit=${pageSize}&page=${page}`))
        );
        pagePayloads.forEach(addProducts);
        if (pagePayloads.some((pageProducts) => pageProducts.length < pageSize)) break;
      }

      window.__piVehicleTextMatchCatalogProducts = products;
      writeProductCache(VEHICLE_TEXT_MATCH_CACHE_KEY, products);
      return products;
    })();

    return window.__piVehicleTextMatchCatalogPromise;
  }

  async function findTextMatchedProductHandles(selection, standardResults) {
    const handles = [];
    const seenHandles = new Set();
    const addHandle = (handle) => {
      if (!handle || seenHandles.has(handle)) return;
      seenHandles.add(handle);
      handles.push(handle);
    };

    if (standardResults) {
      $$('[data-product-card]', standardResults)
        .filter((card) => productTextMatchesVehicle(card, selection))
        .forEach((card) => addHandle(card.dataset.productHandle || ''));
    }

    const catalogProducts = await loadVehicleTextMatchCatalogProducts();
    catalogProducts
      .filter((product) => productTextMatchesVehicle(product, selection))
      .forEach((product) => addHandle(product.handle || ''));

    return handles;
  }

  function uniqueSorted(values, sorter) {
    return Array.from(new Set(values.filter(Boolean))).sort(sorter || ((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })));
  }

  function buildVehicleCard(product) {
    const price = typeof product.price === 'number' ? formatMoney(product.price) : '';
    const compare = typeof product.compare_at_price === 'number' && product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : '';
    const available = Boolean(product.available);
    const hasSaleBadge = typeof product.compare_at_price === 'number' && product.compare_at_price > product.price;
    const hasNewBadge = Array.isArray(product.tags) && product.tags.includes('New');
    const badgeText = !available ? 'Sold out' : (hasSaleBadge ? 'Sale' : (hasNewBadge ? 'New' : ''));
    const image = Array.isArray(product.images) && product.images.length
      ? `<img src="${product.images[0]}" alt="${escapeHTML(product.title || '')}" loading="lazy">`
      : '<div class="pi-product-fallback"></div>';
    const variantId = product.variants?.[0]?.id || '';
    const fitmentText = getProductFitmentText(product);
    const excludeFitment = isFitmentExcludedProduct(product);
    const quickMeta = escapeHTML(String(product.type || product.product_type || '').replace(/United States/gi, '').replace(/PARTS ISLAND/gi, '').trim());
    return `
      <div class="card pi-product-card${badgeText ? ' has-product-badge' : ''}" data-product-card data-product-handle="${escapeHTML(product.handle || '')}" data-product-title="${escapeHTML(product.title || '')}" data-product-type="${escapeHTML(product.type || product.product_type || '')}" data-product-fitment-text="${escapeHTML(fitmentText)}" data-product-universal="${isUniversalProduct(product)}" data-product-tags="${escapeHTML(Array.isArray(product.tags) ? product.tags.join(',') : (product.tags || ''))}" data-product-collections="${escapeHTML(Array.isArray(product.collections) ? product.collections.join('|') : (product.collections || ''))}" data-product-exclude-fitment="${excludeFitment}">
        <div class="pi-product-card__top${badgeText ? ' has-product-badge' : ''}">
          <a href="/products/${product.handle}" class="pi-product-media" aria-label="${escapeHTML(product.title || '')}">${image}</a>
          ${badgeText ? `<span class="pi-product-badge">${badgeText}</span>` : ''}
          ${excludeFitment ? '' : '<div class="pi-fit-status pi-fit-status--overlay" data-fit-status data-fit-status-mode="overlay" hidden></div>'}
        </div>
        <div class="pi-product-body">
          <div class="pi-product-body__content">
            <h3 class="pi-product-title"><a href="/products/${product.handle}">${escapeHTML(product.title || '')}</a></h3>
            ${quickMeta ? `<div class="pi-product-copy">${quickMeta}</div>` : ''}
            ${excludeFitment ? '' : '<div class="pi-fit-status pi-fit-status--inline" data-fit-status data-fit-status-mode="inline" hidden></div>'}
            <div class="pi-product-meta-row">
              <div class="pi-product-price-wrap">
                <span class="pi-product-price">${price}</span>
                ${compare ? `<span class="pi-product-compare">${compare}</span>` : ''}
              </div>
              <span class="pi-stock-pill${available ? '' : ' is-out'}">${available ? 'In stock' : 'Out of stock'}</span>
            </div>
          </div>
          <div class="pi-product-body__footer">
            ${variantId ? `
            <form action="${window.themeRoutes.cartAdd}" method="post" class="pi-product-form pi-product-form--card" data-ajax-add-to-cart>
              <input type="hidden" name="id" value="${variantId}">
              <div class="pi-product-card__purchase">
                <div class="pi-product-card__stock-qty-row">
                  <span class="pi-stock-pill pi-stock-pill--mobile-form${available ? '' : ' is-out'}">${available ? 'In stock' : 'Out of stock'}</span>
                  <div class="pi-qty-inline pi-qty-inline--card pi-qty-control">
                    <span class="pi-qty-prefix">Qty:</span>
                    <input class="pi-qty-input pi-qty-input--inline" type="number" name="quantity" value="1" min="1" inputmode="numeric">
                    <button type="button" class="pi-qty-btn pi-qty-btn--inline" data-qty-increase aria-label="Increase quantity">+</button>
                  </div>
                </div>
                <button type="submit" class="pi-btn pi-btn--primary" ${available ? '' : 'disabled'}>${available ? 'Add to cart' : 'Sold out'}</button>
              </div>
            </form>` : ''}
          </div>
        </div>
      </div>`;
  }

  function bindDynamicCardEvents(scope) {
    $$('form[data-ajax-add-to-cart]', scope).forEach((form) => {
      if (form.dataset.vehicleBound === 'true') return;
      form.dataset.vehicleBound = 'true';
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submit = e.submitter || $('button[type="submit"]', form);
        const isBuyNow = !!(submit && submit.matches('[data-buy-now]'));
        if (submit) submit.disabled = true;
        const formData = new FormData(form);
        try {
          const res = await fetch(window.themeRoutes.cartAdd, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          });
          if (!res.ok) throw new Error('Cart add failed');
          if (isBuyNow) {
            window.location.href = '/checkout';
            return;
          }
          await refreshCartDrawer();
          openCartDrawer();
        } catch (err) {
          window.location.href = isBuyNow ? '/checkout' : window.themeRoutes.cart;
        } finally {
          if (!isBuyNow && submit) submit.disabled = false;
        }
      });
    });
    $$('[data-qty-increase]', scope).forEach((btn) => {
      if (btn.dataset.vehicleBound === 'true') return;
      btn.dataset.vehicleBound = 'true';
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.pi-qty-control') || btn.closest('.pi-qty-inline');
        const input = $('input[type="number"]', wrap);
        if (!input) return;
        input.stepUp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function normalizeVehicleValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isAllEngines(engine) {
    return normalizeVehicleValue(engine) === 'all engines';
  }

  function getStoredVehicleSelection() {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = {
      year: params.get('vehicle_year') || '',
      make: params.get('vehicle_make') || '',
      model: params.get('vehicle_model') || '',
      engine: params.get('vehicle_engine') || ''
    };
    if (fromUrl.year && fromUrl.make && fromUrl.model) return fromUrl;
    try {
      const stored = JSON.parse(localStorage.getItem('piVehicleSelection') || '{}');
      return {
        year: stored.year || '',
        make: stored.make || '',
        model: stored.model || '',
        engine: stored.engine || ''
      };
    } catch (e) {
      return { year: '', make: '', model: '', engine: '' };
    }
  }

  function storeVehicleSelection(selection) {
    if (!selection?.year || !selection?.make || !selection?.model) return;
    try {
      localStorage.setItem('piVehicleSelection', JSON.stringify(selection));
    } catch (e) {
      /* ignore */
    }
    syncVehicleTriggerUI(selection);
  }

  function clearVehicleSelection() {
    try {
      localStorage.removeItem('piVehicleSelection');
    } catch (e) {
      /* ignore */
    }
    syncVehicleTriggerUI({ year: '', make: '', model: '', engine: '' });
  }

  function vehicleSelectionLabel(selection) {
    if (!selection?.year || !selection?.make || !selection?.model) return '';
    return [selection.year, selection.make, selection.model, selection.engine && !isAllEngines(selection.engine) ? selection.engine : '']
      .filter(Boolean)
      .join(' ');
  }

  function vehicleTriggerLabel(selection) {
    if (!selection?.year || !selection?.make || !selection?.model) return 'My Vehicle';
    return [selection.year, selection.make, selection.model].filter(Boolean).join(' ');
  }

  function syncVehicleTriggerUI(selection) {
    const currentSelection = selection || getStoredVehicleSelection();
    const isSelected = !!(currentSelection?.year && currentSelection?.make && currentSelection?.model);
    const label = vehicleTriggerLabel(currentSelection);
    $$('[data-vehicle-trigger-label]').forEach((el) => {
      el.textContent = label;
      el.setAttribute('title', label);
    });
    $$('[data-vehicle-trigger-check]').forEach((el) => {
      el.hidden = !isSelected;
    });
    $$('[data-open-vehicle]').forEach((btn) => {
      btn.classList.toggle('is-selected', isSelected);
    });
  }

  function isUniversalProduct(productOrElement) {
    if (!productOrElement) return false;
    if (productOrElement.dataset) {
      const flag = normalizeVehicleValue(productOrElement.dataset.productUniversal) === 'true';
      const tags = normalizeVehicleValue(productOrElement.dataset.productTags);
      return flag || tags.includes('universal');
    }
    const tags = Array.isArray(productOrElement.tags) ? productOrElement.tags.join(',') : String(productOrElement.tags || '');
    const productType = String(productOrElement.type || productOrElement.product_type || '');
    return normalizeVehicleValue(`${tags} ${productType}`).includes('universal');
  }

  const FITMENT_EXCLUDED_CATEGORY_TERMS = [
    'tire and wheel',
    'tire wheel',
    'tires and wheels',
    'tire wheels',
    'wheels and tires',
    'battery and chargers',
    'battery chargers',
    'batteries chargers',
    'battery charger',
    'battery',
    'batteries',
    'charger',
    'chargers',
    'tools and garage equipment',
    'tools garage equipment',
    'garage equipment',
    'garage tools',
    'battery jumper cable',
    'jumper cable',
    'jumper cables',
    'booster cable',
    'booster cables',
    'interior accessories',
    'interior accessory',
    'exterior accessories',
    'exterior accessory',
    'oil fluids and chemicals',
    'oil fluids chemicals',
    'fluids and chemicals',
    'fluids chemicals',
    'motor oil',
    'engine oil',
    'fluid',
    'fluids',
    'chemical',
    'chemicals',
    'coolant',
    'antifreeze',
    'lubricant',
    'lubricants',
    'grease',
    'wash and wax',
    'wash wax',
    'car wash',
    'detailing',
    'detailer',
    'cleaner',
    'cleaners',
    'polish',
    'wax',
    'audio systems',
    'audio system',
    'car audio',
    'stereo',
    'speaker',
    'speakers',
    'subwoofer',
    'subwoofers',
    'amplifier',
    'amplifiers',
    'radio',
    'jump starter',
    'jump starters',
    'battery booster',
    'shop management software',
    'shop management',
    'chip tuning',
    'performance chip',
    'ecu tuning',
    'software'
  ];

  const FITMENT_EXCLUDED_TITLE_TERMS = [
    'tire',
    'tires',
    'tyre',
    'tyres',
    'wheel',
    'wheels',
    'wheel rim',
    'wheel rims',
    'rim',
    'rims',
    'alloy wheel',
    'steel wheel',
    'engine oil',
    'motor oil',
    'oil additive',
    'oil treatment',
    'transmission fluid',
    'brake fluid',
    'power steering fluid',
    'washer fluid',
    'coolant',
    'antifreeze',
    'grease',
    'lubricant',
    'wash and wax',
    'car wash',
    'detailing',
    'detailer',
    'cleaner',
    'polish',
    'wax',
    'battery',
    'batteries',
    'battery charger',
    'battery chargers',
    'jump starter',
    'jump starters',
    'jumper cable',
    'jumper cables',
    'booster cable',
    'booster cables',
    'audio system',
    'car audio',
    'stereo',
    'speaker',
    'speakers',
    'subwoofer',
    'subwoofers',
    'amplifier',
    'amplifiers',
    'radio',
    'bluetooth',
    'shop management',
    'software'
  ];

  const FITMENT_PROTECTED_TITLE_TERMS = [
    'oil filter',
    'engine oil filter',
    'transmission oil filter',
    'air filter',
    'cabin filter',
    'fuel filter',
    'filter kit',
    'ignition coil',
    'coil pack',
    'coil boot',
    'wheel bearing',
    'wheel hub',
    'hub bearing',
    'wheel cylinder',
    'wheel speed sensor',
    'abs wheel speed sensor',
    'wheel seal',
    'wheel stud',
    'wheel nut',
    'lug nut',
    'lug bolt',
    'steering wheel',
    'flywheel',
    'spoiler'
  ];

  const FITMENT_EXCLUDED_EXACT_TYPES = [
    'tire',
    'tires',
    'wheel',
    'wheels',
    'rim',
    'rims',
    'oil',
    'motor oil',
    'engine oil',
    'fluid',
    'fluids',
    'chemical',
    'chemicals',
    'battery',
    'batteries',
    'charger',
    'chargers',
    'jump starter',
    'jumper cable',
    'audio',
    'stereo',
    'software'
  ];


  const FITMENT_FORCE_INCLUDED_CATEGORY_TERMS = [
    'brake',
    'brakes',
    'brake pad',
    'brake pads',
    'brake kit',
    'brake kits',
    'brake rotor',
    'brake rotors',
    'rotor',
    'rotors',
    'caliper',
    'calipers',
    'disc brake',
    'disc brakes',
    'drum brake',
    'drum brakes'
  ];

  const FITMENT_FORCE_INCLUDED_TITLE_TERMS = [
    'brake pad',
    'brake pads',
    'brake kit',
    'brake kits',
    'brake rotor',
    'brake rotors',
    'semi metallic brake',
    'ceramic brake',
    'drilled slotted brake',
    'drilled and slotted brake',
    'rotor and pad',
    'rotors and pads',
    'caliper',
    'calipers'
  ];

  const FITMENT_FORCE_INCLUDED_BLOCKED_TITLE_TERMS = [
    'brake fluid',
    'brake cleaner',
    'brake lubricant',
    'brake grease'
  ];

  function normalizeFitmentText(value) {
    return normalizeVehicleValue(value)
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hasFitmentPhrase(source, terms) {
    const normalizedSource = ` ${normalizeFitmentText(source)} `;
    if (normalizedSource.trim() === '') return false;
    return terms.some((term) => {
      const normalizedTerm = normalizeFitmentText(term);
      return normalizedTerm && normalizedSource.includes(` ${normalizedTerm} `);
    });
  }

  function splitFitmentValues(value) {
    if (Array.isArray(value)) return value.map((item) => String(item || ''));
    return String(value || '').split(/[,|]+/).map((item) => item.trim()).filter(Boolean);
  }

  function hasExactFitmentField(fields, exactTerms) {
    return fields.some((field) => {
      const normalizedField = normalizeFitmentText(field);
      return normalizedField && exactTerms.some((term) => normalizedField === normalizeFitmentText(term));
    });
  }

  function getProductFitmentText(productOrElement) {
    if (productOrElement?.dataset) {
      return [
        productOrElement.dataset.productFitmentText || '',
        productOrElement.dataset.productTitle || '',
        productOrElement.dataset.productHandle || '',
        productOrElement.dataset.productVariants || ''
      ].filter(Boolean).join(' ');
    }

    const variantTitles = Array.isArray(productOrElement?.variants)
      ? productOrElement.variants.map((variant) => variant?.title || variant?.name || '').join(' ')
      : '';
    const tags = Array.isArray(productOrElement?.tags)
      ? productOrElement.tags.join(' ')
      : String(productOrElement?.tags || '');

    return [
      productOrElement?.title || '',
      productOrElement?.handle || '',
      productOrElement?.description || '',
      productOrElement?.body_html || '',
      productOrElement?.content || '',
      variantTitles,
      tags
    ].filter(Boolean).join(' ');
  }

  function compactFitmentValue(value) {
    return normalizeFitmentText(value).replace(/\s+/g, '');
  }

  function fitmentTextIncludesAlias(normalizedSource, alias) {
    const normalizedAlias = normalizeFitmentText(alias);
    if (!normalizedAlias || normalizedAlias.length < 2) return false;
    if (` ${normalizedSource} `.includes(` ${normalizedAlias} `)) return true;

    const compactAlias = compactFitmentValue(normalizedAlias);
    if (compactAlias.length < 3 || !/[a-z]/.test(compactAlias) || !/\d/.test(compactAlias)) return false;
    return compactFitmentValue(normalizedSource).includes(compactAlias);
  }

  function getVehicleMakeAliases(make) {
    const rawMake = String(make || '').trim();
    const aliases = new Set([rawMake]);
    rawMake.split(/[\/\-]+/).forEach((part) => {
      if (part.trim()) aliases.add(part.trim());
    });

    const normalizedMake = normalizeFitmentText(rawMake);
    const aliasMap = {
      chevrolet: ['chevy'],
      'mercedes benz': ['mercedes', 'benz'],
      volkswagen: ['vw'],
      'lincoln mercury': ['lincoln', 'mercury'],
      alfa: ['alfa romeo'],
      fiat: ['fiat'],
      gmc: ['gmc']
    };

    (aliasMap[normalizedMake] || []).forEach((alias) => aliases.add(alias));
    return Array.from(aliases).map(normalizeFitmentText).filter((alias) => alias.length >= 2);
  }

  const MODEL_ALIAS_STOP_WORDS = [
    '2wd', '4wd', 'awd', 'fwd', 'rwd', '4x4', '4x2',
    'quattro', 'xdrive', 'sdrive', 'all4', 'hemi', 'mhev', 'hev', 'phev', 'ev', 'hybrid', 'electric',
    'sedan', 'coupe', 'convertible', 'hatchback', 'wagon', 'van', 'cab', 'chassis', 'pickup',
    'crew', 'double', 'extended', 'regular', 'supercrew', 'supercab', 'access', 'mega',
    'sport', 'sports', 'touring', 'limited', 'premium', 'luxury', 'base', 'standard', 'special',
    'platinum', 'titanium', 'denali', 'trailhawk', 'trailboss', 'trailsport', 'badlands',
    'with', 'wheel', 'wheels', 'tire', 'tires', 'mud', 'terrain', 'track', 'pack',
    '2dr', '3dr', '4dr', '5dr', 'door', 'doors'
  ];

  function addModelAlias(aliases, value) {
    const normalized = normalizeFitmentText(value);
    if (!normalized) return;
    aliases.add(normalized);

    const tokens = normalized.split(' ').filter(Boolean);
    if (!tokens.length) return;

    const stopIndex = tokens.findIndex((token, index) => index > 0 && MODEL_ALIAS_STOP_WORDS.includes(token));
    const baseTokens = stopIndex > 0 ? tokens.slice(0, stopIndex) : tokens;
    if (baseTokens.length) aliases.add(baseTokens.join(' '));

    const compactBase = baseTokens.join('');
    if (/[a-z]/.test(compactBase) && /\d/.test(compactBase)) aliases.add(compactBase);
  }

  const MODEL_FAMILY_SUFFIX_WORDS = [
    '1500', '2500', '3500', '4500', '5500', 'hd', 'classic', 'new', 'legacy',
    'awd', 'fwd', 'rwd', '4wd', '2wd', '4x4', '4x2', 'quattro', 'xdrive', 'sdrive',
    'sport', 'sports', 'limited', 'premium', 'base', 'hybrid', 'electric', 'ev'
  ];

  const MODEL_FAMILY_BLOCKED_WORDS = [
    'class', 'series', 'model', 'all', 'new', 'old', 'van', 'truck', 'pickup',
    'sedan', 'coupe', 'wagon', 'hatchback', 'hybrid', 'electric', 'sport', 'base'
  ];

  function addModelFamilyAlias(aliases, value) {
    const normalized = normalizeFitmentText(value);
    if (!normalized) return;
    const tokens = normalized.split(' ').filter(Boolean);
    if (tokens.length < 2) return;

    let familyTokens = tokens.slice();
    while (familyTokens.length > 1 && MODEL_FAMILY_SUFFIX_WORDS.includes(familyTokens[familyTokens.length - 1])) {
      familyTokens.pop();
    }

    const family = familyTokens.join(' ');
    if (!family || family === normalized) return;
    const firstToken = familyTokens[0] || '';
    if (firstToken.length < 4 || MODEL_FAMILY_BLOCKED_WORDS.includes(firstToken)) return;
    aliases.add(family);
  }

  const SIMPLE_MODEL_FAMILY_ROOTS = [
    'accord', 'civic', 'crv', 'cr v', 'crz', 'cr z', 'crosstour', 'fit', 'odyssey', 'pilot',
    'silverado', 'sierra', 'tahoe', 'suburban', 'avalanche', 'yukon', 'escalade',
    'charger', 'challenger', 'magnum', 'ram', 'dakota', 'durango',
    'forester', 'legacy', 'outback', 'impreza', 'wrx', 'crosstrek',
    'camry', 'corolla', 'tacoma', 'tundra', 'rav4', 'highlander', 'sienna',
    'f150', 'f 150', 'f250', 'f 250', 'f350', 'f 350', 'focus', 'fusion', 'escape', 'explorer', 'expedition', 'ranger',
    'altima', 'sentra', 'maxima', 'pathfinder', 'frontier', 'titan', 'rogue',
    'sonata', 'elantra', 'santa fe', 'tucson',
    'optima', 'sorento', 'sportage', 'soul',
    'q5', 'q7', 'x3', 'x5', 'x6'
  ];

  function addSimpleModelFamilyRootAlias(aliases, value) {
    const normalized = normalizeFitmentText(value);
    if (!normalized) return;
    const compactNormalized = compactFitmentValue(normalized);

    SIMPLE_MODEL_FAMILY_ROOTS.forEach((root) => {
      const normalizedRoot = normalizeFitmentText(root);
      if (!normalizedRoot) return;
      const compactRoot = compactFitmentValue(normalizedRoot);
      if (normalized === normalizedRoot || normalized.startsWith(`${normalizedRoot} `) || compactNormalized.startsWith(compactRoot)) {
        aliases.add(normalizedRoot);
        aliases.add(compactRoot);
      }
    });

    const firstToken = normalized.split(' ').filter(Boolean)[0] || '';
    if (firstToken.length >= 5 && !MODEL_FAMILY_BLOCKED_WORDS.includes(firstToken)) {
      aliases.add(firstToken);
    }
  }

  function getVehicleModelAliases(model) {
    const rawModel = String(model || '').replace(/\([^)]*\)/g, ' ');
    const aliases = new Set();
    addModelAlias(aliases, rawModel);
    addModelFamilyAlias(aliases, rawModel);
    addSimpleModelFamilyRootAlias(aliases, rawModel);
    rawModel.split(/[\/]+/).forEach((part) => {
      addModelAlias(aliases, part);
      addModelFamilyAlias(aliases, part);
      addSimpleModelFamilyRootAlias(aliases, part);
    });

    return Array.from(aliases)
      .filter((alias) => alias.length >= 3 || (/^[a-z]\s?\d+$/i.test(alias) && alias.length >= 2))
      .sort((a, b) => b.length - a.length);
  }

  function fitmentValueAliasesMatch(valueA, valueB) {
    const normalizedA = normalizeFitmentText(valueA);
    const normalizedB = normalizeFitmentText(valueB);
    if (!normalizedA || !normalizedB) return false;
    if (normalizedA === normalizedB) return true;

    const paddedA = ` ${normalizedA} `;
    const paddedB = ` ${normalizedB} `;
    if (paddedA.includes(` ${normalizedB} `) || paddedB.includes(` ${normalizedA} `)) return true;

    const compactA = compactFitmentValue(normalizedA);
    const compactB = compactFitmentValue(normalizedB);
    return compactA.length >= 3 && compactB.length >= 3 && (compactA === compactB || compactA.includes(compactB) || compactB.includes(compactA));
  }

  function vehicleModelsMatch(modelA, modelB) {
    if (fitmentValueAliasesMatch(modelA, modelB)) return true;
    const aliasesA = getVehicleModelAliases(modelA);
    const aliasesB = getVehicleModelAliases(modelB);
    return aliasesA.some((aliasA) => aliasesB.some((aliasB) => fitmentValueAliasesMatch(aliasA, aliasB)));
  }

  function isStrongModelAliasForMakeOptional(alias) {
    const normalized = normalizeFitmentText(alias);
    const compact = compactFitmentValue(normalized);
    if (!compact) return false;
    if (/[a-z]/.test(compact) && /\d/.test(compact)) return true;
    return compact.length >= 5 && !MODEL_FAMILY_BLOCKED_WORDS.includes(normalized);
  }

  function productTextHasSelectedYear(source, selectedYear) {
    const year = Number(selectedYear);
    if (!year) return false;

    const text = String(source || '')
      .replace(/&(ndash|mdash|minus|hyphen);/gi, '-')
      .replace(/&#8211;|&#8212;|&#8722;|&#45;/gi, '-')
      .replace(/[–—−‑‒]/g, '-');
    const rangePattern = /((?:19|20)\d{2})\s*(?:-|to|thru|through)\s*((?:19|20)?\d{2})/gi;
    let rangeMatch;
    while ((rangeMatch = rangePattern.exec(text)) !== null) {
      const start = Number(rangeMatch[1]);
      let end = Number(rangeMatch[2]);
      if (end < 100) {
        end = Math.floor(start / 100) * 100 + end;
        if (end < start) end += 100;
      }
      if (year >= Math.min(start, end) && year <= Math.max(start, end)) return true;
    }

    const escapedYear = String(selectedYear).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const exactYearPattern = new RegExp(`(^|\\D)${escapedYear}(?=\\D|$)`);
    return exactYearPattern.test(text);
  }

  function getEngineDisplacementTokens(value) {
    const tokens = new Set();
    const source = String(value || '').replace(/,/g, '.');
    const addLiters = (liters) => {
      const amount = Number(liters);
      if (!Number.isFinite(amount) || amount <= 0 || amount > 20) return;
      tokens.add(amount.toFixed(2).replace(/0+$/, '').replace(/\.$/, ''));
    };

    let match;
    const literPattern = /(\d{1,2}(?:\.\d{1,2})?)\s*(?:l|liters?|litres?)\b/gi;
    while ((match = literPattern.exec(source)) !== null) addLiters(match[1]);

    const ccPattern = /\b(\d{3,5})\s*cc\b/gi;
    while ((match = ccPattern.exec(source)) !== null) addLiters(Number(match[1]) / 1000);

    return Array.from(tokens);
  }

  function productTextMatchesSelectedEngine(source, selectedEngine) {
    if (!selectedEngine || isAllEngines(selectedEngine)) return true;
    const selectedDisplacements = getEngineDisplacementTokens(selectedEngine);
    if (!selectedDisplacements.length) return true;

    // Only restrict a text match when the product itself states an engine size.
    // Listings without engine information continue to use the accepted year + model rule.
    const productDisplacements = getEngineDisplacementTokens(source);
    if (!productDisplacements.length) return true;
    return selectedDisplacements.some((value) => productDisplacements.includes(value));
  }

  function productTextMatchesVehicle(productOrElement, selection) {
    if (!selection?.year || !selection?.make || !selection?.model || !productOrElement) return false;
    if (isFitmentExcludedProduct(productOrElement)) return false;

    const source = getProductFitmentText(productOrElement);
    if (!source || !productTextHasSelectedYear(source, selection.year)) return false;

    const normalizedSource = normalizeFitmentText(source);
    const matchedModelAlias = getVehicleModelAliases(selection.model).find((alias) => fitmentTextIncludesAlias(normalizedSource, alias));
    if (!matchedModelAlias) return false;
    if (!productTextMatchesSelectedEngine(source, selection.engine)) return false;

    const makeMatch = getVehicleMakeAliases(selection.make).some((alias) => fitmentTextIncludesAlias(normalizedSource, alias));
    if (makeMatch) return true;

    // Keep the rule simple for vehicle-fitment parts: year + a strong selected model family
    // in the product title/description is enough to mark it as a fit. This catches listings
    // like "2002-2014 Silverado" for a Chevrolet Silverado 1500 without forcing every
    // listing to repeat the make name.
    return isStrongModelAliasForMakeOptional(matchedModelAlias);
  }

  function getFitmentExclusionFields(productOrElement) {
    if (productOrElement?.dataset) {
      return {
        title: productOrElement.dataset.productTitle || '',
        handle: productOrElement.dataset.productHandle || '',
        type: productOrElement.dataset.productType || '',
        tags: splitFitmentValues(productOrElement.dataset.productTags || ''),
        collections: splitFitmentValues(productOrElement.dataset.productCollections || ''),
        explicitExclude: normalizeVehicleValue(productOrElement.dataset.productExcludeFitment) === 'true'
      };
    }
    return {
      title: String(productOrElement?.title || ''),
      handle: String(productOrElement?.handle || ''),
      type: String(productOrElement?.type || productOrElement?.product_type || ''),
      tags: splitFitmentValues(productOrElement?.tags || ''),
      collections: splitFitmentValues(productOrElement?.collections || ''),
      explicitExclude: false
    };
  }

  function isForceIncludedFitmentProductFromFields(fields) {
    const categoryFields = [fields.type, ...fields.tags, ...fields.collections];
    const categorySource = categoryFields.join(' ');
    const titleSource = `${fields.title} ${fields.handle}`;
    const combinedSource = `${titleSource} ${categorySource}`;

    if (hasFitmentPhrase(titleSource, FITMENT_FORCE_INCLUDED_BLOCKED_TITLE_TERMS)) return false;

    return hasFitmentPhrase(categorySource, FITMENT_FORCE_INCLUDED_CATEGORY_TERMS)
      || hasFitmentPhrase(titleSource, FITMENT_FORCE_INCLUDED_TITLE_TERMS)
      || hasFitmentPhrase(combinedSource, FITMENT_PROTECTED_TITLE_TERMS);
  }

  function isFitmentExcludedProduct(productOrElement) {
    if (!productOrElement) return false;

    const fields = getFitmentExclusionFields(productOrElement);
    const forceIncluded = isForceIncludedFitmentProductFromFields(fields);
    if (fields.explicitExclude && !forceIncluded) return true;
    if (forceIncluded) return false;

    const categoryFields = [fields.type, ...fields.tags, ...fields.collections];
    const categorySource = categoryFields.join(' ');
    const titleSource = `${fields.title} ${fields.handle}`;

    if (hasExactFitmentField(categoryFields, FITMENT_EXCLUDED_EXACT_TYPES)) return true;
    if (hasFitmentPhrase(categorySource, FITMENT_EXCLUDED_CATEGORY_TERMS)) return true;

    if (hasFitmentPhrase(titleSource, FITMENT_PROTECTED_TITLE_TERMS)) return false;

    return hasFitmentPhrase(titleSource, FITMENT_EXCLUDED_TITLE_TERMS);
  }

  function vehicleFitsProduct(fitments, selection) {
    if (!Array.isArray(fitments) || !selection?.year || !selection?.make || !selection?.model) return false;
    return fitments.some((item) => {
      const makeOnly = Boolean(item.make_only) || String(item.year || '') === '*' || String(item.model || '') === '*';
      const yearMatch = makeOnly || String(item.year || '') === String(selection.year || '');
      const makeMatch = getVehicleMakeAliases(selection.make).some((alias) => fitmentValueAliasesMatch(item.make, alias));
      const modelMatch = makeOnly || vehicleModelsMatch(item.model, selection.model);
      const selectedAllEngines = !selection.engine || isAllEngines(selection.engine);
      const itemSupportsAllEngines = !item.engine || isAllEngines(item.engine);
      const engineMatch = selectedAllEngines || itemSupportsAllEngines || normalizeVehicleValue(item.engine) === normalizeVehicleValue(selection.engine);
      return yearMatch && makeMatch && modelMatch && engineMatch;
    });
  }

  function syncProductPageLayoutState(hasVehicleSelection) {
    $$('[data-product-summary-card]').forEach((card) => {
      card.classList.toggle('is-vehicle-selected', !!hasVehicleSelection);
      card.classList.toggle('is-no-vehicle-selected', !hasVehicleSelection);
    });
    $$('[data-product-main-form]').forEach((form) => {
      form.classList.toggle('is-vehicle-selected', !!hasVehicleSelection);
      form.classList.toggle('is-no-vehicle-selected', !hasVehicleSelection);
    });
  }

  function getProductFitmentSortState(productOrElement, data, selection) {
    const currentSelection = selection || getStoredVehicleSelection();
    const isReady = currentSelection.year && currentSelection.make && currentSelection.model;
    if (!isReady || !productOrElement) {
      return { rank: 4, type: 'default' };
    }

    if (isFitmentExcludedProduct(productOrElement)) {
      return { rank: 2, type: 'no-fitment' };
    }

    const handle = productOrElement.dataset?.productHandle || productOrElement.handle || '';
    const fitments = data?.by_handle?.[handle] || [];
    const fits = vehicleFitsProduct(fitments, currentSelection);
    const textFits = productTextMatchesVehicle(productOrElement, currentSelection);
    const universal = isUniversalProduct(productOrElement);

    if (fits || textFits) {
      return { rank: 0, type: 'fit' };
    }
    if (universal) {
      return { rank: 1, type: 'universal' };
    }
    if (!fitments.length) {
      return { rank: 2, type: 'no-fitment' };
    }
    return { rank: 3, type: 'maybe' };
  }

  function sortProductCardsByFitment(data, selection) {
    const currentSelection = selection || getStoredVehicleSelection();
    const isReady = currentSelection.year && currentSelection.make && currentSelection.model;
    const grids = $$('[data-product-grid], [data-vehicle-results-grid]');
    grids.forEach((grid) => {
      const cards = $$('[data-product-card]', grid);
      if (!cards.length) return;

      cards.forEach((card, index) => {
        if (!card.dataset.fitmentOriginalIndex) {
          card.dataset.fitmentOriginalIndex = String(index);
        }
      });

      if (!isReady) {
        cards
          .slice()
          .sort((a, b) => Number(a.dataset.fitmentOriginalIndex || 0) - Number(b.dataset.fitmentOriginalIndex || 0))
          .forEach((card) => grid.appendChild(card));
        return;
      }

      const decorated = cards.map((card) => {
        const state = getProductFitmentSortState(card, data, currentSelection);
        return {
          card,
          rank: state.rank,
          originalIndex: Number(card.dataset.fitmentOriginalIndex || 0)
        };
      });

      const hasVehicleFitmentOrder = decorated.some((item) => item.rank === 0 || item.rank === 1 || item.rank === 3);
      if (!hasVehicleFitmentOrder) return;

      decorated
        .sort((a, b) => (a.rank - b.rank) || (a.originalIndex - b.originalIndex))
        .forEach((item) => grid.appendChild(item.card));
    });
  }


  function getCollectionPriorityPageCount(grid) {
    const pageSize = Number(grid?.dataset?.pageSize) || 24;
    const productCount = Number(grid?.dataset?.collectionProductCount) || 0;
    const fromCount = productCount > pageSize ? Math.ceil(productCount / pageSize) : 1;
    const fromLinks = $$('.pi-pagination a').reduce((max, link) => {
      try {
        const page = Number(new URL(link.getAttribute('href'), window.location.origin).searchParams.get('page'));
        return page > max ? page : max;
      } catch (e) {
        return max;
      }
    }, 1);
    return Math.max(1, fromCount, fromLinks || 1);
  }

  function getVehicleSelectionKey(selection) {
    return [selection?.year || '', selection?.make || '', selection?.model || '', selection?.engine || '']
      .map((value) => normalizeVehicleValue(value))
      .join('|');
  }

  function getCollectionHandleFromUrl(collectionUrl) {
    try {
      const url = new URL(collectionUrl || window.location.pathname, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const collectionIndex = parts.indexOf('collections');
      return collectionIndex >= 0 ? parts[collectionIndex + 1] || '' : '';
    } catch (e) {
      return '';
    }
  }

  function getCollectionProductCacheKey(handle, productCount) {
    return `piCollectionProducts:${handle || 'collection'}:${Number(productCount || 0)}:v2`;
  }

  async function loadCollectionProductsForFitmentPriority(grid) {
    const collectionUrl = grid?.dataset?.collectionUrl || window.location.pathname;
    const handle = getCollectionHandleFromUrl(collectionUrl);
    if (!handle) return [];

    const productCount = Number(grid?.dataset?.collectionProductCount) || 0;
    const cacheKey = getCollectionProductCacheKey(handle, productCount);
    const requiredTags = JSON.parse(grid.dataset.requiredTags || '[]') || [];
    const matchesSubmenu = (product) => requiredTags.every((tag) => product.tags.includes(tag));
    const cached = readProductCache(cacheKey);
    if (cached) return cached.filter(matchesSubmenu);

    const pageSize = 250;
    const maxPages = Math.min(4, Math.max(1, Math.ceil((productCount || pageSize) / pageSize)));
    const pages = Array.from({ length: maxPages }, (_, index) => index + 1);
    const payloads = await Promise.all(
      pages.map((page) => fetchProductsJsonPage(`/collections/${encodeURIComponent(handle)}/products.json?limit=${pageSize}&page=${page}`))
    );

    const products = [];
    const seenHandles = new Set();
    payloads.flat().forEach((product) => {
      const normalized = normalizeCatalogProductForFitment(product);
      const productHandle = normalized?.handle || '';
      if (!productHandle || seenHandles.has(productHandle)) return;
      seenHandles.add(productHandle);
      products.push(normalized);
    });

    writeProductCache(cacheKey, products);
    return products.filter(matchesSubmenu);
  }

  function restoreCollectionGridFitmentPriority() {
    const grid = $('[data-product-grid][data-collection-url]:not([data-vehicle-results-grid])');
    if (!grid || typeof grid.__piFitmentPriorityOriginalHtml !== 'string') return false;
    const currentView = grid.dataset.view || 'grid';
    grid.innerHTML = grid.__piFitmentPriorityOriginalHtml;
    grid.dataset.view = currentView;
    delete grid.__piFitmentPriorityOriginalHtml;
    delete grid.dataset.fitmentPriorityHydratedKey;
    delete grid.dataset.fitmentPriorityHydrating;
    const pagination = $('.pi-pagination');
    if (pagination) pagination.hidden = Boolean(grid.__piFitmentPriorityPaginationHidden);
    delete grid.__piFitmentPriorityPaginationHidden;
    if (typeof bindDynamicCardEvents === 'function') bindDynamicCardEvents(grid);
    return true;
  }

  async function hydrateCollectionGridForFitmentPriority(data, selection) {
    const currentSelection = selection || getStoredVehicleSelection();
    const isReady = currentSelection.year && currentSelection.make && currentSelection.model;
    if (!isReady) return false;

    const grid = $('[data-product-grid][data-collection-url]:not([data-vehicle-results-grid])');
    if (!grid || $('[data-tire-wheel-filters]')) return false;
    if (grid.dataset.sizeFilterActive === 'true') return false;

    const pageCount = getCollectionPriorityPageCount(grid);
    if (pageCount <= 1) return false;

    const selectionKey = getVehicleSelectionKey(currentSelection);
    if (grid.dataset.fitmentPriorityHydratedKey === selectionKey) return false;
    if (grid.dataset.fitmentPriorityHydrating === 'true') return false;

    grid.dataset.fitmentPriorityHydrating = 'true';
    const currentView = grid.dataset.view || 'grid';

    try {
      const products = await loadCollectionProductsForFitmentPriority(grid);
      if (!products.length) return false;

      const decorated = products.map((product, index) => {
        const state = getProductFitmentSortState(product, data, currentSelection);
        return { product, rank: state.rank, title: product.title || '', originalIndex: index };
      });

      const hasPriorityFit = decorated.some((item) => item.rank === 0);
      if (!hasPriorityFit) {
        return restoreCollectionGridFitmentPriority();
      }

      decorated.sort((a, b) => (a.rank - b.rank) || String(a.title).localeCompare(String(b.title), undefined, { numeric: true, sensitivity: 'base' }) || (a.originalIndex - b.originalIndex));

      if (typeof grid.__piFitmentPriorityOriginalHtml !== 'string') {
        grid.__piFitmentPriorityOriginalHtml = grid.innerHTML;
        const pagination = $('.pi-pagination');
        grid.__piFitmentPriorityPaginationHidden = pagination ? pagination.hidden : false;
      }

      grid.innerHTML = decorated.map((item) => buildVehicleCard(item.product)).join('');
      grid.dataset.view = currentView;
      grid.dataset.fitmentPriorityHydratedKey = selectionKey;
      grid.classList.toggle('pi-products--single-card', decorated.length === 1);

      const pagination = $('.pi-pagination');
      if (pagination) pagination.hidden = true;

      if (typeof bindDynamicCardEvents === 'function') bindDynamicCardEvents(grid);
      return true;
    } finally {
      delete grid.dataset.fitmentPriorityHydrating;
    }
  }


  function ensureProductCardFitmentStatusElements(card) {
    if (!card || !card.matches?.('[data-product-card]')) return;

    const top = $('.pi-product-card__top', card);
    if (top && !$('[data-fit-status][data-fit-status-mode="overlay"]', top)) {
      const overlay = document.createElement('div');
      overlay.className = 'pi-fit-status pi-fit-status--overlay';
      overlay.dataset.fitStatus = '';
      overlay.dataset.fitStatusMode = 'overlay';
      overlay.hidden = true;
      overlay.setAttribute('hidden', 'hidden');
      top.appendChild(overlay);
    }

    const content = $('.pi-product-body__content', card);
    if (content && !$('[data-fit-status][data-fit-status-mode="inline"]', content)) {
      const inline = document.createElement('div');
      inline.className = 'pi-fit-status pi-fit-status--inline';
      inline.dataset.fitStatus = '';
      inline.dataset.fitStatusMode = 'inline';
      inline.hidden = true;
      inline.setAttribute('hidden', 'hidden');
      const metaRow = $('.pi-product-meta-row', content);
      if (metaRow) {
        content.insertBefore(inline, metaRow);
      } else {
        content.appendChild(inline);
      }
    }
  }

  function updateFitmentStatusBadges(data, selection, options = {}) {
    const currentSelection = selection || getStoredVehicleSelection();
    const isReady = currentSelection.year && currentSelection.make && currentSelection.model;
    if (!isReady) restoreCollectionGridFitmentPriority();
    syncProductPageLayoutState(isReady);
    $$('[data-product-card], [data-product-page-fit-status]').forEach((item) => {
      if (item.matches?.('[data-product-card]') && !isFitmentExcludedProduct(item)) {
        ensureProductCardFitmentStatusElements(item);
      }
      const statuses = $$('[data-fit-status]', item);
      const fallbackStatus = item.matches?.('[data-fit-status]') ? [item] : [];
      const statusEls = statuses.length ? statuses : fallbackStatus;
      const clearStatuses = () => {
        statusEls.forEach((status) => {
          status.hidden = true;
          status.setAttribute('hidden', 'hidden');
          status.innerHTML = '';
          status.classList.remove('is-fit', 'is-universal', 'is-maybe');
        });
      };
      if (isFitmentExcludedProduct(item)) {
        clearStatuses();
        return;
      }
      if (!statusEls.length) return;
      if (!isReady) {
        clearStatuses();
        return;
      }
      const state = getProductFitmentSortState(item, data, currentSelection);
      let statusClass = 'is-maybe';
      let statusMarkup = '<span class="pi-fit-status__icon" aria-hidden="true">!</span><span class="pi-fit-status__text">May not fit your vehicle</span>';
      if (state.type === 'fit') {
        statusClass = 'is-fit';
        statusMarkup = '<span class="pi-fit-status__icon" aria-hidden="true">✓</span><span class="pi-fit-status__text">Fits your vehicle</span>';
      } else if (state.type === 'universal') {
        statusClass = 'is-universal';
        statusMarkup = '<span class="pi-fit-status__icon" aria-hidden="true">✓</span><span class="pi-fit-status__text">Universal Fit</span>';
      }
      statusEls.forEach((status) => {
        status.hidden = false;
        status.removeAttribute('hidden');
        status.classList.remove('is-fit', 'is-universal', 'is-maybe');
        status.classList.add(statusClass);
        status.innerHTML = statusMarkup;
      });
    });
    sortProductCardsByFitment(data, currentSelection);
    if (!options.skipPriorityHydration) {
      const runPriorityHydration = () => {
        hydrateCollectionGridForFitmentPriority(data, currentSelection)
          .then((didHydrate) => {
            if (didHydrate) {
              updateFitmentStatusBadges(data, currentSelection, { ...options, skipPriorityHydration: true });
            }
          })
          .catch(() => {});
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(runPriorityHydration, { timeout: 700 });
      } else {
        window.setTimeout(runPriorityHydration, 120);
      }
    }
  }

  function vehicleSelectionCopy(year, make, model, engine, count) {
    const label = [year, make, model, engine && !isAllEngines(engine) ? engine : ''].filter(Boolean).join(' ');
    return {
      title: label ? `Parts for ${label}` : 'Vehicle Parts',
      copy: count === 1 ? '1 matching product found.' : `${count} matching products found.`
    };
  }

  async function initVehicleFinder() {
    const data = await loadVehicleFinderData();
    const finderForms = $$('[data-vehicle-finder]');
    const catalog = data?.catalog && typeof data.catalog === 'object' ? data.catalog : null;
    const mappedFitments = Array.isArray(data?.fitments) ? data.fitments : [];
    const engineDatabase = data?.engine_database && typeof data.engine_database === 'object' ? data.engine_database : null;
    const selectedVehicle = getStoredVehicleSelection();

    const yearsFromCatalog = catalog ? uniqueSorted(Object.keys(catalog), (a, b) => Number(b) - Number(a)) : [];
    const getMakesForYear = (year) => {
      if (!year) return [];
      if (catalog && catalog[year]) return uniqueSorted(Object.keys(catalog[year] || {}));
      return uniqueSorted(mappedFitments.filter((item) => item.year === year).map((item) => item.make));
    };
    const getModelsForYearMake = (year, make) => {
      if (!year || !make) return [];
      if (catalog && catalog[year] && catalog[year][make]) return uniqueSorted(catalog[year][make] || []);
      return uniqueSorted(mappedFitments.filter((item) => item.year === year && normalizeVehicleValue(item.make) === normalizeVehicleValue(make)).map((item) => item.model));
    };
    const getEnginesForVehicle = (year, make, model) => {
      if (!year || !make || !model) return [];
      const overrides = engineDatabase?.overrides?.[year]?.[make]?.[model];
      if (Array.isArray(overrides) && overrides.length) {
        return uniqueSorted(overrides);
      }
      const mappedEngines = uniqueSorted(
        mappedFitments
          .filter((item) =>
            item.year === year &&
            normalizeVehicleValue(item.make) === normalizeVehicleValue(make) &&
            normalizeVehicleValue(item.model) === normalizeVehicleValue(model) &&
            item.engine
          )
          .map((item) => item.engine)
      );
      if (mappedEngines.length) return mappedEngines;
      const defaults = Array.isArray(engineDatabase?.default) && engineDatabase.default.length ? engineDatabase.default : ['All Engines'];
      return uniqueSorted(defaults);
    };

    if (finderForms.length && (catalog || mappedFitments.length)) {
      finderForms.forEach((form) => {
        const yearSelect = $('[data-vehicle-year]', form);
        const makeSelect = $('[data-vehicle-make]', form);
        const modelSelect = $('[data-vehicle-model]', form);
        const engineSelect = $('[data-vehicle-engine]', form);
        const submit = $('[data-vehicle-submit]', form);
        const message = $('[data-vehicle-message]', form);
        const finderCard = form.closest('[data-vehicle-finder-card]');
        const isProductFinder = finderCard?.dataset.vehicleFinderContext === 'product';
        const isDrawerFinder = finderCard?.classList.contains('pi-vehicle-finder-card--drawer');
        const selectionBox = finderCard?.querySelector('[data-vehicle-current]');
        const selectionLabel = selectionBox?.querySelector('[data-vehicle-current-label]');
        const selectedCopy = finderCard?.querySelector('[data-vehicle-selected-copy]');
        const heading = finderCard?.querySelector('[data-vehicle-heading]');
        const helperText = finderCard?.querySelector('[data-vehicle-helper]');
        const actionsWrap = form.querySelector('[data-vehicle-actions]');
        const changeButton = form.querySelector('[data-vehicle-change]');
        const removeButton = form.querySelector('[data-vehicle-remove]');
        if (!yearSelect || !makeSelect || !modelSelect || !engineSelect || !submit) return;

        const years = yearsFromCatalog.length ? yearsFromCatalog : uniqueSorted(mappedFitments.map((item) => item.year), (a, b) => Number(b) - Number(a));
        yearSelect.innerHTML = '<option value="">Select year</option>' + years.map((year) => `<option value="${year}">${year}</option>`).join('');

        const syncSelectionUI = () => {
          const selection = {
            year: yearSelect.value,
            make: makeSelect.value,
            model: modelSelect.value,
            engine: engineSelect.value
          };
          const isCompleteSelection = !!(selection.year && selection.make && selection.model && selection.engine);
          const label = isCompleteSelection ? vehicleSelectionLabel(selection) : '';
          if (selectionBox) selectionBox.hidden = !label;
          if (selectionLabel) selectionLabel.textContent = label;
          if (selectedCopy) {
            selectedCopy.textContent = label || '';
            selectedCopy.hidden = !label;
          }
          if (heading) {
            heading.textContent = label
              ? (heading.dataset.vehicleSelectedHeading || 'Selected Vehicle:')
              : (heading.dataset.vehicleDefaultHeading || 'Find parts that match your vehicle');
          }
          if (helperText) helperText.hidden = !!label;
          if (actionsWrap) actionsWrap.hidden = !isCompleteSelection;
        };

        const resetEngines = () => {
          engineSelect.innerHTML = '<option value="">Select engine</option>';
          engineSelect.disabled = true;
          submit.disabled = true;
        };

        const updateMakes = () => {
          const year = yearSelect.value;
          const makes = getMakesForYear(year);
          makeSelect.innerHTML = '<option value="">Select make</option>' + makes.map((make) => `<option value="${make}">${make}</option>`).join('');
          makeSelect.disabled = !year || !makes.length;
          modelSelect.innerHTML = '<option value="">Select model</option>';
          modelSelect.disabled = true;
          resetEngines();
        };

        const updateModels = () => {
          const year = yearSelect.value;
          const make = makeSelect.value;
          const models = getModelsForYearMake(year, make);
          modelSelect.innerHTML = '<option value="">Select model</option>' + models.map((model) => `<option value="${model}">${model}</option>`).join('');
          modelSelect.disabled = !year || !make || !models.length;
          resetEngines();
        };

        const updateEngines = () => {
          const year = yearSelect.value;
          const make = makeSelect.value;
          const model = modelSelect.value;
          const engines = getEnginesForVehicle(year, make, model);
          engineSelect.innerHTML = '<option value="">Select engine</option>' + engines.map((engine) => `<option value="${engine}">${engine}</option>`).join('');
          engineSelect.disabled = !year || !make || !model || !engines.length;
          submit.disabled = true;
        };

        const updateSubmit = () => {
          const ready = yearSelect.value && makeSelect.value && modelSelect.value && engineSelect.value;
          submit.disabled = !ready;
          submit.hidden = isProductFinder;
          if (isDrawerFinder) {
            if (message) message.hidden = true;
            syncSelectionUI();
            return;
          }
          if (!message) return;
          if (ready) {
            const selection = { year: yearSelect.value, make: makeSelect.value, model: modelSelect.value, engine: engineSelect.value };
            storeVehicleSelection(selection);
            if (isProductFinder) {
              updateFitmentStatusBadges(data, selection, { showProductPageStatus: true });
              message.textContent = '';
              message.hidden = true;
            } else {
              updateFitmentStatusBadges(data, selection, { showProductPageStatus: false });
              message.textContent = '';
              message.hidden = true;
            }
            syncSelectionUI();
          } else {
            updateFitmentStatusBadges(data, { year: '', make: '', model: '', engine: '' }, { showProductPageStatus: false });
            message.textContent = 'Update your vehicle selection above.';
            message.hidden = true;
            syncSelectionUI();
          }
        };

        if (selectedVehicle.year) {
          yearSelect.value = selectedVehicle.year;
          updateMakes();
          if (selectedVehicle.make) {
            makeSelect.value = selectedVehicle.make;
            updateModels();
          }
          if (selectedVehicle.model) {
            modelSelect.value = selectedVehicle.model;
            updateEngines();
          }
          if (selectedVehicle.engine) {
            engineSelect.value = selectedVehicle.engine;
          }
          updateSubmit();
        } else {
          syncSelectionUI();
          syncProductPageLayoutState(false);
          submit.hidden = isProductFinder;
          if (message) message.hidden = true;
        }

        if (changeButton && changeButton.dataset.vehicleBound !== 'true') {
          changeButton.dataset.vehicleBound = 'true';
          changeButton.addEventListener('click', () => {
            yearSelect.focus();
            if (message) {
              message.textContent = 'Update your vehicle selection above.';
              message.hidden = false;
            }
          });
        }

        if (removeButton && removeButton.dataset.vehicleBound !== 'true') {
          removeButton.dataset.vehicleBound = 'true';
          removeButton.addEventListener('click', () => {
            clearVehicleSelection();
            yearSelect.value = '';
            updateMakes();
            submit.hidden = isProductFinder;
            if (message) {
              message.textContent = 'Update your vehicle selection above.';
              message.hidden = true;
            }
            syncSelectionUI();
            updateFitmentStatusBadges(data, { year: '', make: '', model: '', engine: '' }, { showProductPageStatus: false });
          });
        }

        yearSelect.addEventListener('change', () => { if (message) message.hidden = true; updateMakes(); updateSubmit(); });
        makeSelect.addEventListener('change', () => { if (message) message.hidden = true; updateModels(); updateSubmit(); });
        modelSelect.addEventListener('change', () => { if (message) message.hidden = true; updateEngines(); updateSubmit(); });
        engineSelect.addEventListener('change', () => { if (message) message.hidden = true; updateSubmit(); });

        form.addEventListener('submit', (event) => {
          const year = yearSelect.value;
          const make = makeSelect.value;
          const model = modelSelect.value;
          const engine = engineSelect.value;
          const selection = { year, make, model, engine };
          const label = [year, make, model, engine].filter(Boolean).join(' ');
          storeVehicleSelection(selection);

          if (isProductFinder) {
            event.preventDefault();
            submit.hidden = true;
            updateFitmentStatusBadges(data, selection, { showProductPageStatus: true });
            if (message) {
              message.textContent = '';
              message.hidden = true;
            }
            syncSelectionUI();
            return;
          }

          if (isDrawerFinder) {
            event.preventDefault();
            updateFitmentStatusBadges(data, selection, { showProductPageStatus: false });
            if (message) {
              message.textContent = '';
              message.hidden = true;
            }
            syncSelectionUI();
            closeVehicleDrawer();
            return;
          }

          updateFitmentStatusBadges(data, selection, { showProductPageStatus: false });

          // Vehicle searches use the vehicle_year/make/model/engine parameters below.
          // Do not submit the vehicle label as the normal storefront search query,
          // so the header search bar stays clean on the vehicle parts results page.
          const qInput = form.querySelector('input[name="q"]');
          if (qInput) qInput.remove();
        });
      });
    }

    const params = new URLSearchParams(window.location.search);
    const year = params.get('vehicle_year') || '';
    const make = params.get('vehicle_make') || '';
    const model = params.get('vehicle_model') || '';
    const engine = params.get('vehicle_engine') || '';
    const resultsRoot = $('[data-vehicle-results-root]');
    const standardResults = $('[data-standard-search-results]');
    if (year && make && model) {
      $$('input[type="search"][name="q"], input[data-predictive-search-input]').forEach((input) => {
        input.value = '';
        input.setAttribute('value', '');
      });
    }
    if (resultsRoot && year && make && model && (catalog || mappedFitments.length)) {
      const grid = $('[data-vehicle-results-grid]', resultsRoot);
      const empty = $('[data-vehicle-results-empty]', resultsRoot);
      const title = $('[data-vehicle-results-title]', resultsRoot);
      const copy = $('[data-vehicle-results-copy]', resultsRoot);
      const matches = mappedFitments.filter((item) => {
        const makeOnly = Boolean(item.make_only) || item.year === '*' || item.model === '*';
        const yearMatch = makeOnly || item.year === year;
        const makeMatch = getVehicleMakeAliases(make).some((alias) => fitmentValueAliasesMatch(item.make, alias));
          const modelMatch = makeOnly || vehicleModelsMatch(item.model, model);
        const itemSupportsAllEngines = !item.engine || isAllEngines(item.engine);
        const selectedAllEngines = !engine || isAllEngines(engine);
        const engineMatch = selectedAllEngines || itemSupportsAllEngines || normalizeVehicleValue(item.engine) === normalizeVehicleValue(engine);
        return yearMatch && makeMatch && modelMatch && engineMatch;
      });
      const mappedHandles = matches.flatMap((item) => item.handles || []);
      const selectedVehicle = { year, make, model, engine };
      resultsRoot.hidden = false;
      if (standardResults) standardResults.hidden = true;
      if (title) title.textContent = `Parts for ${[year, make, model, engine && !isAllEngines(engine) ? engine : ''].filter(Boolean).join(' ')}`;
      if (copy) copy.textContent = '🔎 Searching every corner of the island for the right parts…';
      const textMatchedHandles = await findTextMatchedProductHandles(selectedVehicle, standardResults);
      const handles = uniqueSorted([...mappedHandles, ...textMatchedHandles]);
      const showEmptyVehicleResults = () => {
        resultsRoot.classList.add('is-empty');
        if (title) title.textContent = 'No matching parts for your vehicle just yet.';
        if (copy) copy.textContent = 'But you can still make your ride brand new again with accessories, sound systems, wheels, tires, and more.';
        if (standardResults) standardResults.hidden = true;
        if (grid) {
          grid.innerHTML = '';
          grid.classList.remove('pi-products--single-card', 'pi-search-product-grid--single');
        }
        if (empty) empty.hidden = false;
      };

      if (!handles.length) {
        showEmptyVehicleResults();
      } else if (grid) {
        if (standardResults) standardResults.hidden = true;
        if (empty) empty.hidden = true;
        const catalogProductLookup = new Map((window.__piVehicleTextMatchCatalogProducts || [])
          .map((product) => [product.handle || '', product])
          .filter(([handle]) => handle));
        const products = await Promise.all(handles.map(async (handle) => {
          const cachedProduct = catalogProductLookup.get(handle) || null;
          try {
            const res = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
            if (!res.ok) return cachedProduct;
            return normalizeCatalogProductForFitment(await res.json()) || cachedProduct;
          } catch (e) {
            return cachedProduct;
          }
        }));
        const validProducts = products.filter(Boolean);
        if (!validProducts.length) {
          showEmptyVehicleResults();
        } else {
          const text = vehicleSelectionCopy(year, make, model, engine, validProducts.length);
          resultsRoot.classList.remove('is-empty');
          if (title) title.textContent = text.title;
          if (copy) copy.textContent = text.copy;
          validProducts.sort((a, b) => {
            const stateA = getProductFitmentSortState(a, data, selectedVehicle);
            const stateB = getProductFitmentSortState(b, data, selectedVehicle);
            return (stateA.rank - stateB.rank) || String(a.title || '').localeCompare(String(b.title || ''), undefined, { numeric: true, sensitivity: 'base' });
          });
          grid.innerHTML = validProducts.map(buildVehicleCard).join('');
          grid.classList.add('pi-search-product-grid');
          grid.classList.toggle('pi-products--single-card', validProducts.length === 1);
          grid.classList.toggle('pi-search-product-grid--single', validProducts.length === 1);
          bindDynamicCardEvents(resultsRoot);
          updateFitmentStatusBadges(data, { year, make, model, engine });
        }
      }
    }

    updateFitmentStatusBadges(data, getStoredVehicleSelection());

    const productFitmentBlocks = $$('[data-product-fitment]');
    if (productFitmentBlocks.length && data?.by_handle) {
      productFitmentBlocks.forEach((block) => {
        const handle = block.dataset.productHandle;
        const dynamic = $('[data-product-fitment-dynamic]', block);
        const fitments = data.by_handle?.[handle] || [];
        if (!dynamic || !fitments.length) return;
        const makeOnlyFitments = fitments.filter((item) => item.make_only || item.year === '*' || item.model === '*');
        const label = makeOnlyFitments.length
          ? `<p>Make-level fitment verification applies to this spark plug. Compatible make: ${makeOnlyFitments.map((item) => item.make).filter(Boolean).join(', ')}. Confirm the spark plug reference number and specifications before ordering.</p>`
          : fitments.length <= 8
            ? `<ul>${fitments.map((item) => `<li>${[item.year, item.make, item.model, item.engine && !isAllEngines(item.engine) ? item.engine : ''].filter(Boolean).join(' ')}</li>`).join('')}</ul>`
            : `<p>Compatible with ${[fitments[0].make, fitments[0].model, fitments[0].engine && !isAllEngines(fitments[0].engine) ? fitments[0].engine : ''].filter(Boolean).join(' ')} model years ${fitments[0].year}–${fitments[fitments.length - 1].year}.</p>`;
        dynamic.innerHTML = label;
        block.hidden = false;
      });
    }
  }


  function formatProductPrice(cents) {
    const amount = Number(cents || 0) / 100;
    return `USD ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function updateProductGalleryFromVariant(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    const imageUrl = variant.featured_image.src;
    const imageAlt = variant.featured_image.alt || '';
    const imageId = variant.featured_image.id ? String(variant.featured_image.id) : '';

    $$('[data-gallery-main]').forEach((mainImage) => {
      mainImage.src = imageUrl;
      mainImage.srcset = '';
      mainImage.setAttribute('data-zoom-src', imageUrl);
      if (imageAlt) mainImage.alt = imageAlt;
    });
    $$('[data-gallery-zoom-image]').forEach((zoomImage) => {
      zoomImage.src = imageUrl;
      zoomImage.srcset = '';
      if (imageAlt) zoomImage.alt = imageAlt;
    });

    $$('[data-product-mobile-gallery]').forEach((mobileGallery) => {
      const mobileTrack = $('[data-product-mobile-gallery-track]', mobileGallery);
      const mobileSlides = $$('[data-mobile-gallery-slide]', mobileGallery);
      if (!mobileTrack || !mobileSlides.length) return;

      let mobileSlide = imageId
        ? $(`[data-mobile-gallery-slide][data-image-id="${imageId}"]`, mobileGallery)
        : null;

      // The mobile swipe gallery intentionally renders only the first ten
      // product images. If a variant image is outside that set, reuse the
      // first slide so the selected variant image is still shown immediately.
      if (!mobileSlide) {
        mobileSlide = mobileSlides[0];
        const mobileImage = $('img', mobileSlide);
        if (mobileImage) {
          mobileImage.src = imageUrl;
          mobileImage.removeAttribute('srcset');
          mobileImage.removeAttribute('sizes');
          if (imageAlt) mobileImage.alt = imageAlt;
        }
        if (imageId) {
          mobileSlide.dataset.imageId = imageId;
        } else {
          mobileSlide.removeAttribute('data-image-id');
        }
        mobileSlide.dataset.mobileZoomSrc = imageUrl;
        if (imageAlt) mobileSlide.dataset.mobileImageAlt = imageAlt;
      }

      const mobileZoomImage = $('[data-mobile-gallery-zoom-image]', mobileGallery);
      if (mobileZoomImage) {
        mobileZoomImage.src = imageUrl;
        mobileZoomImage.removeAttribute('srcset');
        if (imageAlt) mobileZoomImage.alt = imageAlt;
      }

      const targetIndex = Math.max(0, mobileSlides.indexOf(mobileSlide));
      $$('[data-mobile-gallery-dot]', mobileGallery).forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === targetIndex);
      });

      const targetLeft = Math.max(0, mobileSlide.offsetLeft - mobileTrack.offsetLeft);
      try {
        mobileTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });
      } catch (error) {
        mobileTrack.scrollLeft = targetLeft;
      }
    });
  }

  function initProductVariantPickers() {
    $$('[data-product-variant-picker]').forEach((picker) => {
      const form = picker.closest('form[data-product-main-form]');
      const variantsJson = $('[data-product-variants-json]', picker);
      const variantInventoryJson = $('[data-product-variant-inventory-json]', picker);
      if (!form || !variantsJson) return;

      let variants = [];
      let variantInventoryById = {};
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      try {
        variantInventoryById = variantInventoryJson ? JSON.parse(variantInventoryJson.textContent || '{}') : {};
      } catch (error) {
        variantInventoryById = {};
      }
      if (!variants.length) return;

      const selects = $$('[data-product-option-select]', picker);
      const summaryCard = picker.closest('[data-product-summary-card]') || document;
      const variantInput = $('[data-product-variant-id]', form) || $('input[name="id"]', form);
      const priceEl = $('[data-product-price]', summaryCard) || $('[data-product-price]');
      const compareEl = $('[data-product-compare]', summaryCard) || $('[data-product-compare]');
      const stockPill = $('[data-product-stock-pill]', summaryCard) || $('[data-product-stock-pill]');
      const lowStockIndicator = $('[data-product-low-stock]', summaryCard) || $('[data-product-low-stock]');
      const addToCartButton = $('[data-add-to-cart-button]', form);
      const buyNowButton = $('[data-buy-now]', form);
      const message = $('[data-variant-picker-message]', picker);

      const getSelectedOptionMap = () => {
        const selected = {};
        selects.forEach((select) => {
          selected[String(select.dataset.optionPosition || '')] = select.value;
        });
        return selected;
      };

      const variantMatchesVisibleOptions = (variant, selected) => {
        return Object.entries(selected).every(([position, value]) => {
          if (!position) return true;
          return String(variant[`option${position}`] || '') === String(value || '');
        });
      };

      const getVariantForCurrentSelection = () => {
        const selected = getSelectedOptionMap();
        const matchingVariants = variants.filter((variant) => variantMatchesVisibleOptions(variant, selected));
        return matchingVariants.find((variant) => variant.available) || matchingVariants[0] || null;
      };

      const updateVariantState = () => {
        const variant = getVariantForCurrentSelection();
        const isAvailable = !!(variant && variant.available);

        if (variantInput) variantInput.value = variant ? variant.id : '';

        if (priceEl && variant) {
          priceEl.textContent = formatProductPrice(variant.price);
        }
        if (compareEl) {
          const hasCompare = !!(variant && Number(variant.compare_at_price || 0) > Number(variant.price || 0));
          compareEl.hidden = !hasCompare;
          if (hasCompare) compareEl.textContent = formatProductPrice(variant.compare_at_price);
        }
        if (stockPill) {
          stockPill.classList.toggle('is-unavailable', !isAvailable);
          stockPill.textContent = isAvailable ? 'In Stock' : 'Out of Stock';
        }
        if (lowStockIndicator) {
          const variantId = variant && variant.id ? String(variant.id) : '';
          const mappedInventory = variantId && Object.prototype.hasOwnProperty.call(variantInventoryById, variantId)
            ? Number(variantInventoryById[variantId])
            : NaN;
          const variantInventory = variant ? Number(variant.inventory_quantity) : NaN;
          const inventoryQuantity = Number.isFinite(mappedInventory) ? mappedInventory : variantInventory;
          lowStockIndicator.hidden = !(isAvailable && inventoryQuantity === 1);
        }
        if (addToCartButton) {
          addToCartButton.disabled = !isAvailable;
          addToCartButton.textContent = isAvailable
            ? (addToCartButton.dataset.addToCartLabel || 'Add to cart')
            : (addToCartButton.dataset.soldOutLabel || 'Sold out');
        }
        if (buyNowButton) {
          buyNowButton.hidden = !isAvailable;
          buyNowButton.disabled = !isAvailable;
        }
        if (message) {
          message.hidden = !!variant;
        }

        updateProductGalleryFromVariant(variant);

        if (variant && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      };

      selects.forEach((select) => select.addEventListener('change', updateVariantState));
      updateVariantState();
    });
  }


  function markCurrentPaginationPage() {
    const currentPageNumber = String(Math.max(1, Number(new URL(window.location.href).searchParams.get('page')) || 1));

    $$('.pi-pagination').forEach((pagination) => {
      pagination.setAttribute('role', 'navigation');
      pagination.setAttribute('aria-label', 'Pagination');

      let current = $('.current, .is-current-page, [aria-current="page"]', pagination);

      if (!current) {
        const pageLinks = $$('a', pagination);
        const matchingLink = pageLinks.find((link) => {
          try {
            const linkPage = String(Math.max(1, Number(new URL(link.href, window.location.origin).searchParams.get('page')) || 1));
            return linkPage === currentPageNumber;
          } catch (e) {
            return false;
          }
        });
        if (matchingLink) current = matchingLink.closest('.page') || matchingLink;
      }

      if (!current) {
        current = Array.from(pagination.children).find((item) => {
          if (item.matches?.('.prev, .next, .deco')) return false;
          return item.textContent?.trim() === currentPageNumber;
        }) || null;
      }

      if (!current) return;

      current.classList.add('is-current-page');
      current.setAttribute('aria-current', 'page');
      const currentLink = current.matches?.('a') ? current : $('a', current);
      if (currentLink) {
        currentLink.setAttribute('aria-current', 'page');
        currentLink.setAttribute('aria-label', `Page ${currentPageNumber}, current page`);
      } else {
        current.setAttribute('aria-label', `Page ${currentPageNumber}, current page`);
      }
    });
  }


  const immediateVehicleSearchParams = new URLSearchParams(window.location.search);
  if (immediateVehicleSearchParams.get('vehicle_year') && immediateVehicleSearchParams.get('vehicle_make') && immediateVehicleSearchParams.get('vehicle_model')) {
    $$('input[type="search"][name="q"], input[data-predictive-search-input]').forEach((input) => {
      input.value = '';
      input.setAttribute('value', '');
    });
  }

  markCurrentPaginationPage();
  initProductVariantPickers();
  syncVehicleTriggerUI();
  initVehicleFinder();

})();


/* v70: catalog sidebar category accordion */
(function () {
  function initCatalogSidebarAccordion() {
    const sidebarList = document.querySelector('[data-catalog-sidebar-list]');
    if (!sidebarList || sidebarList.dataset.piAccordionReady === 'true') return;
    sidebarList.dataset.piAccordionReady = 'true';

    const currentUrl = new URL(window.location.href);
    const normalizePath = (path) => (path || '/').replace(/\/$/, '') || '/';
    const currentPath = normalizePath(currentUrl.pathname);
    const sourcePanelByHandle = new Map();

    document.querySelectorAll('.pi-category-dropdown__grid > .pi-category-item').forEach((sourceItem) => {
      const trigger = sourceItem.querySelector('[data-category-submenu-toggle]');
      const sourcePanel = sourceItem.querySelector('[data-category-submenu-panel]');
      const handle = trigger?.dataset.categoryHandle;
      if (handle && sourcePanel) sourcePanelByHandle.set(handle, sourcePanel);
    });

    const setExpanded = (card, panel, expanded) => {
      const handle = card.dataset.categoryHandle || 'category';
      const panelId = 'pi-catalog-sidebar-submenu-' + handle;
      card.setAttribute('aria-expanded', String(expanded));
      card.setAttribute('aria-controls', panelId);
      if (panel) panel.id = panelId;
    };

    const buildPanel = (card) => {
      const sourcePanel = sourcePanelByHandle.get(card.dataset.categoryHandle);
      if (!sourcePanel) return null;
      const panel = sourcePanel.cloneNode(true);
      panel.hidden = false;
      panel.className = 'pi-catalog-sidebar__submenu';
      panel.removeAttribute('aria-label');
      panel.querySelectorAll('.pi-category-submenu__link').forEach((link) => {
        link.classList.remove('pi-category-submenu__link', 'pi-category-submenu__link--all');
        link.classList.add('pi-catalog-sidebar__sublink');
        try {
          const linkUrl = new URL(link.getAttribute('href'), window.location.origin);
          const isCurrent = normalizePath(linkUrl.pathname) === currentPath
            && linkUrl.searchParams.get('q') === currentUrl.searchParams.get('q')
            && (linkUrl.searchParams.get('type') || '') === (currentUrl.searchParams.get('type') || '');
          if (isCurrent) {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
          }
        } catch (error) {
          /* Ignore malformed submenu URLs. */
        }
      });
      return panel;
    };

    sidebarList.querySelectorAll('.pi-catalog-sidebar__item').forEach((card) => {
      if (!sourcePanelByHandle.has(card.dataset.categoryHandle)) return;
      const panel = card.nextElementSibling?.matches('.pi-catalog-sidebar__submenu')
        ? card.nextElementSibling
        : null;
      setExpanded(card, panel, Boolean(panel));
    });

    sidebarList.addEventListener('click', (event) => {
      const card = event.target.closest('.pi-catalog-sidebar__item');
      if (!card || !sidebarList.contains(card)) return;
      if (!sourcePanelByHandle.has(card.dataset.categoryHandle)) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const existingPanel = card.nextElementSibling?.matches('.pi-catalog-sidebar__submenu')
        ? card.nextElementSibling
        : null;
      const shouldOpen = !existingPanel;

      sidebarList.querySelectorAll('.pi-catalog-sidebar__submenu').forEach((panel) => panel.remove());
      sidebarList.querySelectorAll('.pi-catalog-sidebar__item[aria-expanded="true"]').forEach((item) => {
        setExpanded(item, null, false);
      });

      if (!shouldOpen) return;
      const panel = buildPanel(card);
      if (!panel) return;
      card.insertAdjacentElement('afterend', panel);
      setExpanded(card, panel, true);
    });
  }

  const startCatalogSidebarAccordion = () => window.setTimeout(initCatalogSidebarAccordion, 0);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCatalogSidebarAccordion, { once: true });
  } else {
    startCatalogSidebarAccordion();
  }
})();


/* v77: keep mobile catalog location and Back-navigation state in sync */
(function () {
  const normalizePath = (path) => (path || '/').replace(/\/$/, '') || '/';

  const sameCatalogLocation = (href, currentUrl) => {
    try {
      const candidate = new URL(href, window.location.origin);
      if (normalizePath(candidate.pathname) !== normalizePath(currentUrl.pathname)) return false;
      if (normalizePath(candidate.pathname) === '/search') {
        return candidate.searchParams.get('q') === (currentUrl.searchParams.get('catalog_q') || currentUrl.searchParams.get('q'))
          && (candidate.searchParams.get('type') || '') === (currentUrl.searchParams.get('type') || '');
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const catalogPathOf = (href) => {
    try {
      return normalizePath(new URL(href, window.location.origin).pathname);
    } catch (error) {
      return '';
    }
  };

  const setSubmenuOpen = (item, toggle, panel, open) => {
    item.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  };

  const syncCatalogLocation = ({ expandMobile = false } = {}) => {
    const currentUrl = new URL(window.location.href);
    const productCategoryPath = document.body.classList.contains('template-product')
      ? Array.from(document.querySelectorAll('[aria-label="Breadcrumb"] a[href], .pi-breadcrumb a[href]'))
        .map((link) => catalogPathOf(link.getAttribute('href')))
        .reverse()
        .find((path) => path.startsWith('/collections/')) || ''
      : '';

    document.querySelectorAll('.pi-category-dropdown__grid, .pi-mobile-category-grid, .pi-mobile-nav-group--categories .pi-mobile-nav-categories').forEach((grid) => {
      const isMobileGrid = grid.classList.contains('pi-mobile-category-grid') || Boolean(grid.closest('.pi-mobile-nav-group--categories'));

      Array.from(grid.children).forEach((item) => {
        if (item.matches('.pi-category-item')) {
          const toggle = item.querySelector('[data-category-submenu-toggle]');
          const panel = item.querySelector('[data-category-submenu-panel]');
          if (!toggle || !panel) return;

          const submenuLinks = Array.from(panel.querySelectorAll('a[href]'));
          const activeSublink = submenuLinks.find((link) => sameCatalogLocation(link.getAttribute('href'), currentUrl)) || null;
          const mainMatches = sameCatalogLocation(toggle.dataset.categoryMainUrl || '', currentUrl);
          const productCategoryMatches = Boolean(productCategoryPath && catalogPathOf(toggle.dataset.categoryMainUrl || '') === productCategoryPath);
          const isActive = mainMatches || productCategoryMatches || Boolean(activeSublink);

          toggle.classList.toggle('is-active', isActive);
          item.classList.toggle('is-current-category', isActive);
          if (mainMatches) toggle.setAttribute('aria-current', 'page');
          else toggle.removeAttribute('aria-current');

          submenuLinks.forEach((link) => {
            const linkIsActive = link === activeSublink;
            link.classList.toggle('is-active', linkIsActive);
            if (linkIsActive) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          });

          if (isMobileGrid) setSubmenuOpen(item, toggle, panel, Boolean(expandMobile && isActive));
          return;
        }

        if (item.matches('a[href]')) {
          const itemHref = item.getAttribute('href');
          const productCategoryMatches = Boolean(productCategoryPath && catalogPathOf(itemHref) === productCategoryPath);
          const isActive = sameCatalogLocation(itemHref, currentUrl) || productCategoryMatches;
          item.classList.toggle('is-active', isActive);
          if (isActive) item.setAttribute('aria-current', 'page');
          else item.removeAttribute('aria-current');
        }
      });
    });
    document.querySelectorAll('.pi-mobile-nav-group--categories').forEach((group) => {
      const activeCategoryItem = group.querySelector('[aria-current="page"], .is-current-category');
      const summary = group.querySelector('summary');
      group.classList.toggle('is-current-menu-group', Boolean(activeCategoryItem));
      if (summary) summary.classList.toggle('is-active', Boolean(activeCategoryItem));
      if (expandMobile && activeCategoryItem) group.open = true;
    });

    document.querySelectorAll('.pi-mobile-primary-nav a.pi-mobile-nav-link[href]').forEach((link) => {
      const isActive = sameCatalogLocation(link.getAttribute('href'), currentUrl);
      link.classList.toggle('is-active', isActive);
      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    document.querySelectorAll('.pi-mobile-nav-group--policies').forEach((group) => {
      const activePolicyLink = group.querySelector('a.pi-mobile-nav-link[aria-current="page"]');
      const summary = group.querySelector('summary');
      group.classList.toggle('is-current-menu-group', Boolean(activePolicyLink));
      if (summary) summary.classList.toggle('is-active', Boolean(activePolicyLink));
      if (expandMobile && activePolicyLink) group.open = true;
    });
  };

  const closeRestoredMobileDrawer = () => {
    const menu = document.querySelector('#PiMobileMenu');
    const trigger = document.querySelector('[data-mobile-menu-toggle]');
    if (menu) menu.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pi-drawer-lock');
    document.body.classList.remove('pi-drawer-lock');
  };

  const start = () => syncCatalogLocation();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.querySelector('[data-mobile-menu-toggle]')?.addEventListener('click', () => {
    window.requestAnimationFrame(() => {
      syncCatalogLocation({ expandMobile: true });
      const activeMobileItem = document.querySelector(
        '.pi-mobile-category-grid [aria-current="page"], .pi-mobile-category-grid .is-current-category, .pi-mobile-nav-group--categories .pi-mobile-nav-categories [aria-current="page"], .pi-mobile-nav-group--categories .pi-mobile-nav-categories .is-current-category, .pi-mobile-primary-nav a.pi-mobile-nav-link[aria-current="page"]'
      );
      if (!activeMobileItem) return;
      const mobileCategoryGroup = activeMobileItem.closest('.pi-mobile-nav-group');
      if (mobileCategoryGroup) mobileCategoryGroup.open = true;
      window.requestAnimationFrame(() => {
        activeMobileItem.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });
  });

  window.addEventListener('pageshow', () => {
    closeRestoredMobileDrawer();
    syncCatalogLocation();
  });

  window.addEventListener('popstate', () => {
    window.setTimeout(() => {
      closeRestoredMobileDrawer();
      syncCatalogLocation();
    }, 0);
  });

  window.piSyncCatalogLocation = syncCatalogLocation;
})();
